/// <reference path="../paycards.js" />
import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { useSearchParams } from 'react-router-dom';
import moment from "moment";
import Swal from "sweetalert2";

import i18n from "i18next";
import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';
import Icons from 'assets/icons';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
    Form, FormGroup,
    Button, Input, Label, ButtonGroup,
    Modal, ModalHeader, ModalBody, ModalFooter, Row, Col,
    Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";

import { Menu, Item, Separator, useContextMenu } from "react-contexify"
import "react-contexify/dist/ReactContexify.css";

import Select from "react-select"
import TakePhoto from "components/TakePhoto"

import ReportTabFrag from "components/generic/ReportTabFrag"
import TabFrag from "components/generic/TabFrag"
import CategoryFrag from "components/generic/CategoryFrag"
import HeaderFrag from "components/generic/HeaderFrag"
import GroupFrag from "components/generic/GroupFrag"
import ItemsContainerFrag from "components/generic/ItemsContainerFrag"
import EditTextFrag from "components/generic/EditTextFrag"
import SpinnerFrag from "components/generic/SpinnerFrag"
import ImageFrag from "components/generic/ImageFrag"
import ButtonFrag from "components/generic/ButtonFrag"
import CheckboxFrag from "components/generic/CheckboxFrag"
import RadioButtonsFrag from "components/generic/RadioButtonsFrag"
import PictureFrag from "components/generic/PictureFrag"
import TextViewFrag from "components/generic/TextViewFrag"
import FinderFrag from "components/generic/FinderFrag"
import CanvasFrag from "components/generic/CanvasFrag"
import ProgressBarFrag from "components/generic/ProgressBarFrag"
import ChartFrag from "components/generic/ChartFrag"

import AGenerateModel from "components/generic/AGenerateModel"

import SimpleListGeneric from "components/generic/alt/SimpleListGeneric"
import WidgetListGeneric from "components/generic/alt/WidgetListGeneric"

import CImageSelector from "components/CImageSelector"
import OffCanvas from 'components/OffCanvas';
import { GridStack } from 'gridstack';

//Config avec squelette des catégorie
// + data avec attribut=Catégorie
// >> Composant dédié pour afficher le html via config + data
//Voir pour gérer les fonctions du parent dans un objet pour qu'elles soit accessible via string

//Gérer un système de droit (information qui sera récupéré dans le Get de l'objet >> Voir avec Sébastien pour la gueule de l'objet (droit + catégories))


/*
baseValue = defaultValue
propNameType = type
attributes = regex
group = classParent
template = class OU classCollection = class
valueType = type front (Input, Select, TextArea etc…)
required = required
important = champs historique
*/

const tabRules = {
    "String": yup.string(),
    "Int32": yup.number(),
    "Object": yup.object(),
    "object": yup.object(),
};
const inputTypes = {
    "string": "text",
    "number": "number",
    "email": "email",
};

var dataCache = {};
var forcedCreate = false;
var isUpdateGen = false;

const AConfigureModel = React.forwardRef(({ onSubmit, noButtons, appProps, checkRights, getRoutes, getUser, modelsList, parentProps, keyMode, configModel, traceModel, loadedData, children, formEditing }, ref) => {
    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };


    var curGenerateTag = "generate-" + Math.floor(Math.random() * 1000000000);

    if (loadedData) {
        if (loadedData.custom && loadedData.custom.extras && !loadedData.custom.orgExtras) {
            loadedData = JSON.parse(JSON.stringify(loadedData));
            loadedData.custom.orgExtras = loadedData.custom.extras;
            loadedData.custom.extras = {};
            console.debug(loadedData.custom.orgExtras);
            loadedData.custom.orgExtras.forEach((extra) => {
                loadedData.custom.extras[extra.name] = extra.value;
            });
        }
        else if (loadedData.extras && !loadedData.orgExtras) {
            loadedData = JSON.parse(JSON.stringify(loadedData));
            loadedData.orgExtras = loadedData.extras;
            loadedData.extras = {};
            console.debug(loadedData.orgExtras);
            loadedData.orgExtras.forEach((extra) => {
                loadedData.extras[extra.name] = extra.value;
            });
        }
    }

    var waitingFilesCpt = [];
    var needModuleFiles = false;
    var dataModels = {
        category: { objType: "category", title: "Titre Catégorie", headers: [] },
        header: { objType: "header", title: "Titre Sous-Catégorie", groups: [] },
        group: { objType: "group", title: "", items: [] },
        itemsContainer: { objType: "itemsContainer", title: "", children: [] },

        textview: { objType: "textview", title: "TEST" },
        text: { objType: "text", title: "TEST" },
        select: { objType: "select", title: "TEST" },
        dropdown: { objType: "select", title: "TEST" },
        checkbox: { objType: "checkbox", title: "TEST" },
        picture: { objType: "picture", title: "", format: "jpg", gridWidth: 4 },
        canvas: { objType: "canvas", subType: "b64j", title: "Signature", gridWidth: 4 },
        image: { objType: "image", src: "draw:logooskala0", gridWidth: 4 },
        //case "list": break;
        //case "openFile": break;
        //case "planning": break;
        //case "radio": break;

        //Spinner vs Dropdopwn...
        collapsable: { objType: "collapsable", title: "TEST" },
        //case "contact": break;
        //case "carousel": break;
        //case "gmaps": break;
        button: { objType: "button", title: "TEST", gridWidth: 4  },
        openFile: { objType: "openFile", title: "TEST", gridWidth: 4 },
        //case "chart": break;
        //case "finder": break;
        //case "progressBar": break;
        radio: { objType: "radio", title: "TEST", options: [{ title: "Test", "value": "Test" }] },

        //Spec Cpt
        date: { objType: "text", subType: "date_instant", title: "TEST" },
        time: { objType: "text", subType: "time_instant", title: "TEST" },
        email: { objType: "text", subType: "email", title: "TEST" },
        password: { objType: "text", subType: "password", title: "TEST" },
        phone: { objType: "text", subType: "phone", title: "TEST" },
        integer: { objType: "text", subType: "integer", title: "TEST" },
        float: { objType: "text", subType: "float", title: "TEST" }
    };

    var curElementList = {};
    const [elementList, setElementList] = React.useState({});
    const [genModel, setGenModel] = React.useState(configModel);
    const [selectedData, setSelectedData] = React.useState(null);
    const [selectedTabConfig, setSelectedTabConfig] = React.useState("1");
    const [displayMode, setDisplayMode] = React.useState(false);
    const [invalidMerged, setInvalidMerged] = React.useState("1-");
    const [rerender, setRerender] = React.useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    if (formEditing === true || formEditing === false) {
        genModel.disabled = !formEditing;
    }
    isUpdateGen = (loadedData ? !forcedCreate : false);
    forcedCreate = false;

    var modalRoot;
    const showContextMenu = useContextMenu().show;
    const hideAllMenu = useContextMenu().hideAll;

    const modalGenManager = React.createRef();
    const offCanvasReportRef = React.createRef();

    const modelFctManager = {
        modelProps: parentProps,
        rootCache: dataCache,
        getSrcObject: loadedData,
        getRoutes: getRoutes,
        appProps: appProps,
        rootData: genModel,
        checkRights: checkRights,
        onActionRequired: () => {
            return new Promise((resolve, reject) => {
                resolve({ isSuccess: true });
            });
        },
        componentTyped: componentTyped,
        getRgbaFromHex: getRgbaFromHex,
        convertWidthToGrid: convertWidthToGrid,
        prepareMergedDesign: prepareMergedDesign,
        dropManager: dropManager,
        dataModels: dataModels,
        addWaitingFileCpt: (dataCpt, cptNeedModuleFiles) => {
            waitingFilesCpt.push(dataCpt);
            needModuleFiles |= (cptNeedModuleFiles ? true : false);
        },
        setCustomBackground: (design, dataCurrCpt) => {
            var styleObject = { backgroundColor: "", backgroundImage: "" };
            if (design.backColor) {
                if (design.backColor.startsWith("#") || design.backColor === "transparent") styleObject.backgroundColor = getRgbaFromHex(design.backColor);
                //else if (design.backColor.startsWith("icon:")) styleObject.background = design.backColor;//TODO : icon fontawesome
                else {
                    if (design.backColor.startsWith("draw:")) {
                        var sysFile = "";
                        try {
                            sysFile = require("assets/img/res/" + design.backColor.replace("draw:", "").replace("mipmap:", "") + ".png");//TEMP PATCH : supprime l'extension pour compatibilité android
                        }
                        catch (e) {
                            sysFile = require("assets/img/res/" + design.backColor.replace("draw:", "").replace("mipmap:", "") + ".jpg");//TEMP PATCH : supprime l'extension pour compatibilité android
                        }
                        styleObject.backgroundImage = `url("${sysFile}")`;
                    }
                    else if (design.backColor.startsWith("../api") || design.backColor.startsWith("http")) {
                        styleObject.backgroundImage = `url("${design.backColor}")`;
                    }
                    else {
                        var site = modelFctManager.appProps?.getSite();
                        if (site.files?.length) {
                            var siteFile = site.files.filter((file => file.name === design.backColor.replace("/", "")));
                            if (siteFile?.length) {
                                var dt = siteFile[0];
                                const file = {
                                    fileId: dt.idFile,
                                    fileName: dt.name,
                                    container: dt.rootContainer,
                                    etag: dt.etag,
                                    accessToken: dt.absoluteUri,
                                    newWindow: false
                                };
                                styleObject.backgroundImage = `url("../api/data/DownloadFileByUri?${commonFunc.toParams(file)}")`;
                            }
                            else {
                                //Not Found
                            }
                        }
                        else {
                            waitingFilesCpt.push(dataCurrCpt);
                        }
                    }
                    if (!commonFunc.isBlank(styleObject.backgroundImage)) {
                        //styleObject.backgroundRepeat = "no-repeat";
                        //styleObject.backgroundSize = "cover";
                        //styleObject.backgroundPosition = "center";
                        styleObject.alpha = design.alpha;
                        styleObject.hasImage = styleObject.backgroundImage;
                        styleObject.backgroundImage = "";
                    }
                }
            }
            if (design.borderColor || design.borderSize) {
                if (design.borderColor) styleObject.borderColor = getRgbaFromHex(design.borderColor);

                if (design.borderSize) styleObject.borderWidth = design.borderSize;
                else styleObject.borderWidth = "1px";

                styleObject.borderStyle = "solid";
            }
            if (design.borderRadius) styleObject.borderRadius = design.borderRadius;

            return styleObject;
        },
        manageBoxSize: (tag, value, data) => {
            //MAJ gridstack en mode configuration
            if (data.grid) {
                var gridItems = data.grid.getGridItems();
                var filteredItems = gridItems.filter(item => item.id.endsWith(tag));
                if (filteredItems?.length) {
                    var boxSize = parseFloat(value);
                    boxSize = boxSize >= 0.05 ? boxSize : 0.2;
                    data.gridWidth = Math.round(boxSize * 12);
                    data.grid.update(filteredItems[0], { w: data.gridWidth });
                }
            }
            else {
                /*var parentData = data.functionManager?.getParentProps()?.parentData;
                var parentGrid = parentData?.grid;
                if (parentGrid) {
                    var parentGridItems = parentGrid.getGridItems();
                    var parentTag = "item-" + parentData.functionManager?.getParentProps()?.parentData?.gridID + "-" + parentData.key;
                    var filteredParentItems = parentGridItems?.filter(item => (item.id.endsWith(tag) || item.id.endsWith(parentTag)));
                    if (filteredParentItems?.length) {
                        parentGrid.update(filteredParentItems[0], {});
                    }
                }
                else {
                    console.debug("NO GRID " + data.objType + " " + data.bindPropResult);
                }*/
                return convertWidthToGrid(parseFloat(value) * 100);
            }
            return " col-12";
        },
        managePadding: (design, frameClass) => {
            var styleObject = {};
            if (design.padding) {
                styleObject.padding = design.padding;
            }
            if (design.paddingStart) {
                frameClass += " ps-0";
                styleObject.paddingLeft = design.paddingStart;
            }
            if (design.paddingTop) styleObject.paddingTop = design.paddingTop;
            if (design.paddingEnd) {
                frameClass += " pe-0";
                styleObject.paddingRight = design.paddingEnd;
            }
            if (design.paddingBottom) styleObject.paddingBottom = design.paddingBottom;

            return styleObject;
        },
        manageMargin: (design, frameClass) => {
            var styleObject = {};
            //TODO : marginElevation ???
            if (design.margin) {
                frameClass += " p-0";
                styleObject.margin = design.margin;
            }
            if (design.marginStart) {
                frameClass += " ps-0";
                styleObject.marginLeft = design.marginStart;
            }
            if (design.marginTop) styleObject.marginTop = design.marginTop;
            if (design.marginEnd) {
                frameClass += " pe-0";
                styleObject.marginRight = design.marginEnd;
            }
            if (design.marginBottom) styleObject.marginBottom = design.marginBottom;

            return styleObject;
        },
        setSelected: setSelected,
        finalizeProcess: finalizeProcess,
        commonRenderProc: commonRenderProc,
        dataCfg: parentProps ? parentProps.dataCfg : {}
    };

    var yupLocale = t("validation", { returnObjects: true });//TODO : fusion avec un json fourni par GetSchemaModel
    yup.setLocale(yupLocale);

    var keyArgs = ["min", "max", "length", "moreThan", "lessThan"];
    var customYup = {};
    customYup["phoneFr"] = function (yup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return yup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };
    customYup["phone"] = function (yup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)[1-9]{0,3}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return yup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };


    React.useEffect(() => {
        //setElementList(curElementList);

        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
        }
    }, []);


    React.useEffect(() => {
        if (!genModel && traceModel && !commonFunc.isBlank(traceModel)) setGenModel(JSON.parse(traceModel));
    }, [genModel]);

    React.useImperativeHandle(ref, () => ({
        submitForm: (isUpdate) => { handleSubmit((data) => { triggerOnSubmit(data, isUpdate) })() },
        resetForm: () => { reset(); },
    }));

    function triggerOnSubmit(data, isUpdate) {
        //Gestion des extras
        var extras = data.extras;
        data.extras = isUpdate ? (loadedData.custom ? (loadedData.custom.orgExtras || []) : (loadedData.orgExtras || [])) : [];

        var extrasType = parentProps.subType || parentProps.type;
        var primaryId = commonFunc.camelize("ID" + commonFunc.capitalize(extrasType), true);
        var secondaryId = commonFunc.camelize(extrasType + "ID", true);


        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;

        //Exclusion des extras systèmes
        data.extras = data.extras.filter((extra) => {
            var flag = true;
            var cptExtra = dataList[commonFunc.camelize("extras." + extra.name, true)];
            if (cptExtra) {
                flag = !(cptExtra.isExcluded && cptExtra.argumentsObj?.excludeFromExtras);
            }
            return flag;
        });

        if (extras && Object.keys(extras).length) {
            var flagModifElem = false;
            Object.keys(extras).forEach((key) => {
                if (isUpdate) {
                    var existingExtra = data.extras.filter((extra) => extra.name === key);
                    if (existingExtra.length > 0) {
                        existingExtra.forEach((extra) => {
                            flagModifElem |= (extra.value !== extras[key]);
                            extra.value = extras[key];
                        });
                    }
                    else {
                        var extra = { name: key, value: extras[key], idExtra: 0 };
                        extra[secondaryId] = data[primaryId];
                        data.extras.push(extra);
                        flagModifElem = true;
                    }
                }
                else {
                    var extraAdd = { name: key, value: extras[key], idExtra: 0 };
                    extraAdd[secondaryId] = data[primaryId];
                    data.extras.push(extraAdd);
                }
            });
            if (flagModifElem) data.dSysMod = new Date();
        }

        //Vérification validité adresse
        Object.keys(data).forEach((key) => {
            var field = data[key];
            //Reset des valeurs par défaut pour Adresse à -1
            if (field && field.idAddress && field.idAddress === -1) {
                if (!field.avoidReset) {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                }
                else {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child && commonFunc.isBlank(data[key][addressKey]) && data[key][addressKey] !== 0) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                    field.idAddress = 0;
                }

                data[key + "ID"] = 0;
            }
            if (field && field.idAddress !== null && field.idAddress !== undefined && field.idAddress !== data[key + "ID"]) {
                data[key + "ID"] = field.idAddress;
            }
        });

        if (onSubmit) {
            onSubmit(data, isUpdate).then((dataResult) => {
                if (dataResult && dataResult.idResponse) {
                    Object.keys(dataList).forEach((key) => {
                        var dataElem = dataList[key];
                        if (dataElem.onModelSubmited && dataElem.functionManager.onSubmit) {
                            dataElem.functionManager.onSubmit(dataResult, dataResult.idResponse);
                        }
                    });
                }
            });
        }
    }


    //i18n.addResource('fr', 'translation', "tryit.label", 'hello from namespace 1');

    function createNestedObject(base, names, value) {
        // On récupère le dernier argument
        var lastName = arguments.length >= 3 ? names.pop() : false;
        // parcours de l'arbo, création si besoin
        for (var i = 0; i < names.length; i++) {
            base = base[names[i]] = base[names[i]] || {};
        }
        //on affecte la valeur  
        if (lastName) base = base[lastName] = value;
        return base;
    }

    function getValueFromNestedObject(object, value) {
        //récupère la valeur demandée
        return value.split('.').reduce((acc, curr) => acc[curr], object);
    }

    function setYupToNestedObject(obj) {
        //Appel récursif, a check sur plusieurs niveaux
        for (var propertyName in obj) {
            //console.debug(propertyName);
            //console.debug(typeof (obj[propertyName]));
            if (!(obj[propertyName].conditions)) {
                setYupToNestedObject(obj[propertyName]);
                obj[propertyName] = yup.object(obj[propertyName]).notRequired();
            }

        }
    }


    var nestedObj = {};
    var schemaObject = {};
    if (genModel && genModel.templates) {
        genModel.templates?.forEach((template) => {
            template.categories?.forEach((category) => {
                category.headers?.forEach((header) => {
                    header.groups?.forEach((group, index) => {
                        //Gestion des clé primaires/secondaires
                        if (parentProps && parentProps.type && keyMode > 0 && index === 0) {
                            var bindProp = "";
                            switch (keyMode) {
                                case 1: bindProp = "ID" + commonFunc.capitalize(parentProps.type); break;
                                case 2: bindProp = parentProps.type + "ID"; break;
                                default: bindProp = "ID" + parentProps.type; break;
                            }
                            group.items.push({ hidden: true, bindPropResult: bindProp, defaultValue: parentProps.id, objType: "textview" });
                        }

                        group.items?.forEach((item) => {//children
                            var type = item.propNameJsType || "string";
                            if (item.bindPropResult && yup[type] && typeof (yup[type]) === "function" && !item.bindPropResult.startsWith("{array}")) {//TEMP : test sur array en attendant solution pour les contacts de rapport
                                var elemYup = yup[type]();
                                if (item.propNameType) elemYup = tabRules[item.propNameType] || elemYup;
                                elemYup = elemYup.nullable();
                                if (item.attributes) {
                                    var errorMessage;
                                    if (item.attributes["typeName"] === "FormAttribute") errorMessage = altT(item.attributes["error"]);
                                    Object.keys(item.attributes).forEach((key, value) => {
                                        if (elemYup[key] && typeof (elemYup[key]) === "function") {
                                            try {
                                                if (errorMessage) {
                                                    if (keyArgs.indexOf(key) >= 0 && item.attributes[key]) {
                                                        if (key === "min" && type === "date") {
                                                            elemYup = elemYup[key](item.attributes[key], (ref) => {
                                                                return errorMessage.replace("${min}", moment(ref.min).utc().format("DD/MM/yyyy"));
                                                            });
                                                        }
                                                        else {
                                                            elemYup = elemYup[key](item.attributes[key], errorMessage);
                                                        }
                                                    }
                                                    else if (key === "oneOf" && item.attributes[key]) {
                                                        elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))], errorMessage);
                                                    }
                                                    else if (item.attributes[key]) {
                                                        elemYup = elemYup.matches(item.attributes[key], { message: errorMessage, excludeEmptyString: (item.attributes["required"] ? false : true) });
                                                    }
                                                    else {
                                                        elemYup = elemYup[key](errorMessage);
                                                    }
                                                }
                                                else {
                                                    if (keyArgs.indexOf(key) >= 0 && item.attributes[key]) {
                                                        if (key === "min" && type === "date") {
                                                            elemYup = elemYup[key](item.attributes[key], (ref) => {
                                                                return t('validation.date.min').replace("${min}", moment(ref.min).utc().format("DD/MM/yyyy"));
                                                            });
                                                        }
                                                        else {
                                                            elemYup = elemYup[key](item.attributes[key]);
                                                        }
                                                    }
                                                    else if (key === "oneOf" && item.attributes[key]) {
                                                        elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))]);
                                                    }
                                                    else if (item.attributes[key]) {
                                                        elemYup = elemYup.matches(item.attributes[key], { excludeEmptyString: (item.attributes["required"] ? false : true) });
                                                    }
                                                    else {
                                                        elemYup = elemYup[key]();
                                                    }
                                                }
                                            }
                                            catch (e) {
                                                console.debug("Error manipulating yup attributes");
                                                console.error(e);
                                            }
                                        }
                                        else if (customYup[key] && typeof (customYup[key]) === "function") {
                                            elemYup = customYup[key](elemYup, item.attributes[key], (item.attributes["required"] ? false : true), errorMessage);
                                        } else {

                                            //console.debug("yup function type " + key + " Ignored");
                                        }
                                    });
                                }

                                elemYup = elemYup.typeError(t("validation." + type + ".notType"));

                                if (item.bindPropResult.indexOf(".") >= 0) {
                                    if (!item.isExcluded) {
                                        //On met de côté les objets sous-jacents pour traitement final (propriétés non consécutives)
                                        createNestedObject(nestedObj, commonFunc.camelize(item.bindPropResult, true).split("."), elemYup);
                                    }
                                } else {

                                    schemaObject[commonFunc.camelize(item.bindPropResult, true)] = elemYup;//.required()
                                }
                                /*if (item.bindPropResult === "Address.AddressMain" && item.bindPropResult.indexOf(".") >= 0) {
                                    schemaObject["address"] = {};
                                    schemaObject["address"]["addressMain"] = elemYup;
                                }*/


                                //localDataConfig.push({ label: "i18n:" + key + "Label", type: "input", target: key, className: "" });//TEMP
                                if (!item.baseConfig) item.baseConfig = {};
                                //localDataConfig.push({ title: "i18n:report_" + elem.propName + ".label", objType: "text", bindPropResult: elem.propName, defaultValue: elem.baseValue, subType: (inputTypes[elem.propNameJsType] || "text"), readOnly: elem.baseConfig.readOnly, hidden: elem.baseConfig.hidden, isInput: elem.baseConfig.isInput });//TEMP
                            } else {

                                //console.debug("yup base type " + type + " Ignored");
                            }
                        });
                    });
                });
            });
        });
    }
    //TEMP
    /*schemaObject.contacts = yup.array().of(yup.object().shape({
        name: yup.string().required().min(5),
        firstName: yup.string().required().min(5)
    }));*/

    //On genere le yup pour les objets sous-jacents
    setYupToNestedObject(nestedObj);
    Object.assign(schemaObject, nestedObj);

    //console.debug(nestedObj);
    //console.debug(schemaObject);
    //console.debug("....*****");

    const currSchema = yup.object(schemaObject).required();
    const { control, register, getValues, trigger, setValue, resetField, handleSubmit, reset, formState: { errors }, clearErrors } = useForm({ resolver: yupResolver(currSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }
    const formManager = {
        control: control,
        register: register,
        getValues: getValues,
        setValue: setValue,
        resetField: resetField,
        handleSubmit: handleSubmit,
        reset: reset,
        errors: errors
    };

    var cpt = 0;

    //console.debug("ALERTE RENDER !!");
    //console.debug(elementList);

    function finalizeModel(wasRerender) {
        console.debug("ALL ENDED " + wasRerender);

        var filesProcess = (newFiles) => {
            site.files = newFiles;
            if (waitingFilesCpt?.length) {
                waitingFilesCpt.forEach((dataCpt) => {
                    dataCpt?.functionManager?.rerender();
                });
            }
            else {
                //if (genModel?.functionManager?.rerender) genModel.functionManager.rerender(true);
            }
            setRerender(!rerender);
        };


        var site = appProps?.getSite();
        if (!wasRerender) {
            if (site.getFiles || site.files?.length) {
                if (site.getFiles) {
                    //Attente de la récupération des fichiers
                    setTimeout(() => {
                        finalizeModel(wasRerender);
                    }, 2000);
                    return;
                }
                else {
                    filesProcess(site.files);
                }
            }
            else {
                site.getFiles = true;
                commonFunc.getMethod("../api/site/GetSiteFiles", { filetypeID: "SITE", bindID: site.idSite, fileID: -1 }).then((response) => {
                    site.getFiles = false;

                    var dataFiles = response.data;
                    if (dataFiles.isSuccess) {
                        filesProcess(dataFiles.result);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de récupération des fichiers agences<br/>" + dataFiles.errorMessage
                        });
                    }

                    //Gestion interface après rendu

                    //ref.current.style.setProperty("--temp-img", "url(")
                    //data-backimage
                    var backgroundRequired = document.querySelectorAll("[data-backimage]");
                    backgroundRequired.forEach((node) => {
                        node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
                        node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
                    });
                });
                return;
            }
        }
        //Gestion interface après rendu

        //ref.current.style.setProperty("--temp-img", "url(")
        //data-backimage
        var backgroundRequired = document.querySelectorAll("[data-backimage]");
        backgroundRequired.forEach((node) => {
            node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
            node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
        });
    }

    function excludeFrag(bindProp, type) {
        if (bindProp) {
            if (bindProp.indexOf(".") >= 0) {
                var exParent = excludeFrag(bindProp.split(".")[0]);
                return bindProp.replace(bindProp.split(".")[0], exParent) + "_" + (type || "temp");
            }
            else {
                return bindProp + "_" + (type || "temp");
            }
        }
        else {
            return "";
        }
    }

    function commonRenderProc(data) {//TODO : remise a zero nécéssaire pour pas que ça passe tout le temps les prochaines fois
        var parentProps = data?.functionManager?.getParentProps();
        var childCount = parentProps?.parentData?.childCount || 1;
        var childRendered = parentProps?.parentData?.childRendered || 0;

        //console.debug("CHECK RENDERER " + data.objType + " " + data.childRendered + "/" + (data.childCount ? data.childCount : 0));
        //Vérification d'éligibilité de la cible pour gestion parent
        if (data.childRendered >= (data.childCount ? data.childCount : 0)) {
            if (parentProps?.parentData) parentProps.parentData.childRendered = childRendered + 1;

            console.debug("GO RENDERER " + data.objType + " " + parentProps?.parentData?.childRendered + "/" + childCount);

            if (parentProps?.parentData?.childRendered >= childCount /*&& parentProps?.parentData?.loaded*/) {
                var grid = data.grid || parentProps?.parentData?.grid || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.grid
                    || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.grid;
                if (grid) {
                    var itemsHTML = grid.getGridItems();
                    itemsHTML.forEach((item) => {
                        grid.resizeToContent(item);
                    });
                }

                var parentSupProps = parentProps?.parentData?.functionManager?.getParentProps() || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()
                    || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.functionManager?.getParentProps();
                if (parentSupProps) {
                    //if (parentSupProps?.parentData?.childRendered >= childCount) parentSupProps.parentData.childRendered = 0;
                    commonRenderProc(parentProps.parentData);
                }
                else {
                    finalizeModel(true);
                }
            }
        }
    }

    function componentTyped(element, parentElemProps) {
        if (!element.title) element.title = "";
        if (!element.baseConfig) element.baseConfig = {};

        element.key = /*element.key ||*/ (invalidMerged + cpt);
        element.required = element.attributes && (element.attributes.required !== undefined || (element.attributes.min && parseInt(element.attributes.min) > 0));
        if (!element.argumentsObj && element.arguments) {
            if (typeof element.arguments == "string") element.argumentsObj = JSON.parse(element.arguments);
            else { element.argumentsObj = element.arguments; }
        }

        //Préparation du bindPropResult + stockage dans la liste Composant
        var camelBindProp;
        var preventLoadedData = false;
        if (!commonFunc.isBlank(element.bindPropResult)) {
            if (element.bindPropResult.indexOf("{array}") >= 0) {
                camelBindProp = commonFunc.camelize(element.bindPropResult.replace("{array}", commonFunc.camelize(parentElemProps.parentData.isInfluencedBy || parentElemProps.parentData.bindPropResult, true) + (parentElemProps.parentData.isExcluded ? "_temp" : "") + "[" + parentElemProps.parentData.key + "]"), true);
                preventLoadedData = true;
            }
            else {
                camelBindProp = commonFunc.camelize(element.bindPropResult, true);
            }
            curElementList[camelBindProp] = element;
        }
        else {
            camelBindProp = element.bindPropResult;
        }

        cpt++;

        if (!preventLoadedData && (loadedData && !commonFunc.isBlank(camelBindProp))) {
            if (!element.modalDefault) {
                element.modalDefaultValue = element.defaultValue;
                element.modalDefault = true;
            }
            //console.debug(loadedData);
            var srcValue = commonFunc.getValue(loadedData, camelBindProp);
            if (element.objType === "picture") {
                if (typeof srcValue === 'object' && !Array.isArray(srcValue) && srcValue !== null) {
                    element.defaultValue = "";//TODO : Downloadfile valide
                }
                else {
                    element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
                }
            }
            else {
                element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
            }
        }

        //Alimentation du mergedDesign
        manageComponentDesign(element, genModel);


        var args = {
            key: element.key,
            data: element,
            formManager: formManager,
            parentDisabled: (parentElemProps ? parentElemProps.parentDisabled : false),
            parentProps: parentElemProps,
            modelFctManager: modelFctManager,
            isConfiguration: true,
            bindPropResult: (element.isExcluded ? excludeFrag(camelBindProp, element.subType) : camelBindProp),
            tabIndex: parentElemProps?.tabIndex
        };
        switch (element.objType) {
            case "model": return <ReportTabFrag {...args} finalizeModel={finalizeModel} triggerSelection={(template) => {
                if (template) {
                    setSelected(null);
                    if (selectedData !== template) {
                        setSelectedData(template);
                    }
                    setSelectedTabConfig("1");
                }
                return (template || selectedData);
            }} />;
            case "template": return <TabFrag {...args} />;
            case "category": return <CategoryFrag {...args} />;
            case "header": return <HeaderFrag {...args} />;
            case "group": return <GroupFrag {...args} />;
            case "itemsContainer": return <ItemsContainerFrag {...args} />;

            case "image": return <ImageFrag {...args} />;
            case "button": return <ButtonFrag {...args} />;
            case "text": return <EditTextFrag {...args} />;
            case "dropdown":
            case "select":
                return <SpinnerFrag {...args} />;
            case "checkbox": return <CheckboxFrag {...args} />;
            case "radio": return <RadioButtonsFrag {...args} />;
            case "picture": return <PictureFrag {...args} srcFileManager={{ className: curGenerateTag, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu }} />;
            case "textview": return <TextViewFrag {...args} />;
            case "finder": return <FinderFrag {...args} />;
            case "canvas": return <CanvasFrag {...args} />;
            case "progressBar": return <ProgressBarFrag {...args} />;
            case "chart": return <ChartFrag {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;

            case "simpleList": return <SimpleListGeneric {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            case "widgetList": return <WidgetListGeneric {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            default:
                //Finalize quand même sur les composants inexistant pour la gestion du parent
                args.modelFctManager.finalizeProcess(element, args.parentProps);
                return "";
        }
    }


    function renderData(cfg) {
        curElementList = {};

        var content = cfg ? componentTyped(cfg) : "";

        return <Form action="" className={`form needs-validation h-100 ${curGenerateTag}`} method="" onSubmit={handleSubmit((data) => { triggerOnSubmit(data, false) })}>
            <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={saveModel}><i className="fa fa-save me-2"></i>Sauvegarder</Button>
            {false && isUpdateGen ? <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={() => { handleSubmit((data) => { triggerOnSubmit(data, true) })() }}>Modifier</Button> : ""}
            <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={changeDisplay}>Changer Affichage</Button>
            <Button className="btn-round mb-3 float-sm-start" color="danger" onClick={resetModel}>Réinitialiser</Button>
            <Button className="btn-round mb-3 float-sm-start" color="success" onClick={addComponent}>Ajouter Composant</Button>
            <p className="text-dark">TODO : ANNULER</p>
            <Button className="btn-round mb-3 float-sm-start" color="info" onClick={showPreview}><i className="fa fa-eye"></i>Aperçu</Button>
            <div className={`w-100 ${displayMode ? "alt-display" : ""}`}>
                {content}
                {children}
            </div>
        </Form>;
    }

    /*Notes :
        ReportItem :
            //Dictionnaire d'action (onChange/onLoad : évènement où l'appel va se faire | trigger : action à effectuer | target : cible de l'action | value : valeur a communiquer pour l'action)
            onActionEvents: { onChange: [{ trigger: "duplicateManualReport", target: "target1", value: "value" }], onLoad: [{ trigger: "setValue", target: "", value: "options" }] },
    
            
            defaultValue: "10",//Valeur initial du rapport
            rawValue: "2.1",//valeur brut avant formattage
            value: "2",//Valeur finale
            
            rightAccess: "MUPD",//Gestion des drotis d'accès
            isExcluded: true,//Exlusino de la récupération pour sauvegarde
            dataCache : {} //sous objet de gestion de chargement de l'item
                shouldLoadDefaultValue: true, //défini si il faut charger la valeur par défaut dans le ReportItem
                loadFromCache: true//défini si on doit charger les données depuis le cache
                loadWhenGenerating: true//défini si on doit charger les données à la génération du rapport
            schema: {} //objet basé sur GetSchemaModel


            temporary : true //Défini si il s'agit d'un ReportItem qui doit être supprimé si réinitialisation (un peu comme isCloned)
            isLoaded : true //Défini si les traitement ont déjà été effectué sur un fragment

            Design :
                Gérer une option no padding sur parent
                spacing : 1 //Gestion d'un espacement sur les enfants

    */

    //Laison avec commonRenderProc suite au setRerender suivant la fonction depuis la source "onDropped"
    function dropManager(data, event, prevNode, n) {
        var childsList = [...event.target.children];
        childsList.sort(function (a, b) {
            var aX = a.getAttribute("gs-x");
            var aY = a.getAttribute("gs-y");
            var bX = b.getAttribute("gs-x");
            var bY = b.getAttribute("gs-y");
            var tst = parseInt(aY) - parseInt(bY);
            if (!tst) tst = parseInt(aX) - parseInt(bX);
            return tst;
        });
        //Récupération de la position de l'item temporaire
        var index = childsList.indexOf(n.el);
        console.debug(index);
        var nextItem = childsList[index + 1];
        var modif = 1
        /*if (!nextItem) {
            nextItem = childsList[index - 1];
            modif = -1;
        }*/
        if (!nextItem) {
            modif = 0;
        }

        var childsData;
        var tag = "item";
        switch (data?.objType) {
            case "template":
                childsData = data.categories;
                tag = "category";
                break;
            case "category":
                childsData = data.headers;
                tag = "header";
                break;
            case "header":
                childsData = data.groups;
                tag = "group";
                break;
            case "group":
                childsData = data.items;
                break;
            case "itemsContainer":
            default:
                childsData = data.children;
                tag = "subitem";
                break;
        }

        var dataModel;
        var removeElem = false;
        //Ajout nouveau composant
        if (n.el.hasAttribute("bind-type")) {
            removeElem = true;

            //childsData.filter(item => item.id === nextItem.id);

            var tempTest = { customDesign: { design: { backColor: "#FFFF0000" } }, bindPropResult: "extras.added-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) };

            switch (n.el.getAttribute("bind-type")) {
                //case "template": break;// >> Voir dans ReportTabFrag.js 
                case "category":
                    dataModel = { ...dataModels["category"], ...tempTest, bindPropResult: "extras.addedcategory-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) };
                    break;
                case "header":
                    dataModel = { ...dataModels["header"], ...tempTest, bindPropResult: "extras.addedheader-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) };
                    break;
                case "group":
                    dataModel = { ...dataModels["group"], ...tempTest, bindPropResult: "extras.addedgroup-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) };
                    break;
                case "itemsContainer":
                    dataModel = { ...dataModels["itemsContainer"], ...tempTest, bindPropResult: "extras.addeditems-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) };
                    break;
                case "pictureComment":
                    dataModel = {
                        ...dataModels["itemsContainer"],
                        ...tempTest, bindPropResult: "extras.addeditems-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000),
                        customDesign: { design: { boxSize: "1" } },
                        children: [
                            {
                                ...dataModels["picture"], ...tempTest,
                                bindPropResult: "extras.added-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000),
                                gridWidth: 4
                            },
                            {
                                ...dataModels["text"],
                                subType: "text_5",
                                title: "", ...tempTest,
                                bindPropResult: "extras.added-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000),
                                gridWidth: 8, customDesign: { design: { width: "550px" } }
                            }
                        ]
                    };
                    break;
                default: dataModel = { ...dataModels[n.el.getAttribute("bind-type")], ...tempTest }; break;
            }

        }
        //Déplacement composant existant
        else {
            //Remove OldData + getData
            //prevNode.grid.cFunctions.conserve(prevNode.id);
            if (prevNode?.grid?.srcData) {

                //Récupération de l'élément dans le parent pour suppression (React)
                n.el.remove();
                prevNode.grid.el.append(n.el);

                //Suppression
                if (prevNode.grid.cFunctions?.removeItem) {
                    var removedData = prevNode.grid.cFunctions.removeItem(prevNode.id, prevNode.grid);
                    console.debug(removedData);
                    if (removedData && removedData.length) {
                        dataModel = removedData[0];
                    }
                }

                dataModel.key = null;
            }
        }

        //Gestion alimentation des données
        if (!modif) {
            childsData.push(dataModel);
        }
        else {
            var addDone = false;
            //var grid = (childsData && childsData.length ? childsData[0].grid : null);
            var parentGrid = childsData?.filter(child => child.grid ? true : false);
            if (parentGrid && parentGrid.length) {
                var grid = parentGrid[0].grid;
                var gridItems = grid.getGridItems();
                gridItems.forEach(gridItem => {
                    if (gridItem.gridstackNode.el === nextItem) {
                        var target = childsData.filter((item, index) => ((tag + "-" + data.gridID + "-" + (item?.key || index)) === gridItem.gridstackNode.id));
                        if (target && target.length) {
                            var targetIndex = childsData.indexOf(target[0]);

                            if (targetIndex >= 0) {
                                childsData.splice(targetIndex /*- modif*/, 0, dataModel);
                                addDone = true;
                            }
                        }
                    }
                });
            }
            if (!addDone) {
                childsData.push(dataModel);
            }

            console.debug(childsData.map(item => item.bindPropResult).join(";"));
        }
        data.childRendered = 0;

        if (removeElem) n.el.remove();
    }

    function manageComponentDesign(data, genModel) {
        var design = data.customDesign?.design;

        var defaultKey = "";
        switch (data.objType) {
            case "model": defaultKey = "default_model"; break;
            case "template": defaultKey = "default_template"; break;
            case "category": defaultKey = "default_category"; break;
            case "header": defaultKey = "default_header"; break;
            case "group": defaultKey = "default_group"; break;
            case "containerItem":
            case "itemsContainer":
                defaultKey = "default_itemsContainer"; break;

            case "button":
            case "submit":
                defaultKey = "default_button"; break;
            case "text": defaultKey = "default_text"; break;
            case "select":
            case "spinner":
            case "dropdown":
                defaultKey = "default_select"; break;
            case "checkbox": defaultKey = "default_checkbox"; break;
            case "radio": defaultKey = "default_radio"; break;
            case "picture": defaultKey = "default_picture"; break;
            case "textview": defaultKey = "default_textview"; break;
            case "finderText":
            case "finder":
                defaultKey = "default_finder"; break;
            case "canvas": defaultKey = "default_canvas"; break;
            case "progressBar": defaultKey = "default_progressBar"; break;

            case "simpleList": defaultKey = "default_simpleList"; break;
            case "widgetList": defaultKey = "default_widgetList"; break;
            default:
                break;
        }

        design = prepareMergedDesign(data, design, defaultKey);
        data.mergedDesign = design;
    }

    function prepareMergedDesign(data, designFragment, defaultDesignKey, forcedMerge) {
        if (forcedMerge || invalidMerged || !data.mergedDesign) {
            var altDesign = genModel.customDesign?.extrasDesign;
            var targetDesign = (designFragment && !commonFunc.isBlank(designFragment.fromDesign)) ? designFragment.fromDesign : defaultDesignKey;
            var rootDesign = altDesign ? altDesign[targetDesign] : null;

            var returnDesign = getMergedDesign(data, designFragment, rootDesign, (forcedMerge || invalidMerged));

            if (defaultDesignKey.endsWith("Title")) data.mergedDesignTitle = returnDesign;
            else if (defaultDesignKey.endsWith("Icon")) data.mergedDesignIcon = returnDesign;
            else if (defaultDesignKey.endsWith("Input")) data.mergedDesignInput = returnDesign;

            return returnDesign;
        }
        else {
            designFragment = forcedMerge ? designFragment : data.mergedDesign;
        }
        return designFragment;
    }

    function prepareModelToSave(model) {
        const excludeKeys = ["baseConfig", "functionManager", "argumentsObj", "isLoaded", "mergedDesign", "mergedDesignTitle", "mergedDesignInput", "mergedDesignIcon", "grid", "gridWidth", "gridID", "lastEvent", "allowBoxSize",
            "countTabIndex", "tabIndex", "renderValue",
            "key", "loaded", "childCount", "childLoaded", "childRendered", "modalDefault", "modalDefaultValue"];

        return JSON.stringify(model, (key, value) => {
            var foundString = excludeKeys.find(str => str === key);
            if (!commonFunc.isBlank(foundString)) {
                return undefined;
            }
            if (key === "required" && value === true) return undefined;
            if (key === "boxSize" && value === "0") return "";
            return value;
        });
    }


    function saveModel() {
        console.debug(genModel);

        var entity = searchParams.get("entity");
        var categ = searchParams.get("categ");
        var extID = searchParams.get("extID");

        if (entity && extID && categ) {
            Swal.fire({
                title: "Sauvegarde en cours...",
                didOpen: () => { Swal.showLoading() }
            });

            var args = {};
            var url = "api/" + entity;
            if (genModel.idModel) {
                url += "/Update";
                args.idModel = genModel.idModel;
            }
            else {
                url += "/Add";
                args.idModel = 0;
            }
            url += entity;
            url += "Model";

            args.title = "Saved Model";
            args.extID = "SAVED-" + extID;
            args.categ = categ;
            args.value = prepareModelToSave(genModel);


            commonFunc.postMethod("../" + url, args).then((response) => {
                var data = response.data;
                if (data.isSuccess) {
                    Swal.fire({
                        icon: "success",
                        title: "Succès",
                        html: "Sauvegarde de modèle effectuée avec succès.",
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        //window.location.reload();
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de sauvegarde<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Echec",
                html: "Arguments URL pour sauvegarde manquant"
            });
        }
    }

    function changeDisplay() {
        console.debug(prepareModelToSave(genModel));
        setDisplayMode(!displayMode);
    }

    function resetModel() {
        setGenModel(null);
        //if (traceModel && !commonFunc.isBlank(traceModel)) setGenModel(JSON.parse(traceModel));
        //setRerender(!rerender);
    }

    function addComponent() {
        offCanvasReportRef.current.open();

        //TODO : load templates
    }

    function showPreview() {
        var callbackModal = function (dataElem, valueProc) {
            return new Promise((resolve, reject) => {
                if (modalRoot) {
                    modalRoot.unmount();
                    modalRoot = null;
                }
            });
        };

        var modelPrepared = JSON.parse(prepareModelToSave(genModel));

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<SubGenModal t={t} configModel={modelPrepared} appProps={appProps} checkRights={modelFctManager.checkRights} dataCfg={parentProps.dataCfg} getRoutes={modelFctManager.getRoutes} genRef={modalGenManager}
            genId={0} genType={"REPORT"} subType={"REPORT"} itemData={{ subType: "REPORT", argumentsObj: {} }} size={null} title={"Aperçu"} callback={callbackModal} />);
    }

    function setSelected(grid, dataSel) {
        console.debug(dataSel?.lastEvent);
        var selElements = document.getElementsByClassName("selected-item");
        if (grid && dataSel) {
            if (!dataSel?.lastEvent?.target?.classList?.contains("ui-resizable-handle") && !dataSel?.lastEvent?.target?.classList?.contains("remove-gridstack")) {
                setSelectedData(dataSel);
                setSelectedTabConfig("1");

                var gridItems = grid.getGridItems();
                var filteredItems = gridItems.filter((item) => { return item.id.endsWith(dataSel.functionManager?.getParentProps()?.parentData?.gridID + "-" + dataSel.key); });
                if (filteredItems.length) {
                    if (!filteredItems[0].classList.contains("selected-item")) {
                        if (selElements && selElements.length) {
                            Array.from(selElements).forEach((elem) => {
                                elem.classList.remove("selected-item");
                            });
                        }
                        filteredItems[0].classList.add("selected-item");
                    }
                    else {
                        filteredItems[0].classList.remove("selected-item");
                        setSelectedData(null);
                        setSelectedTabConfig("1");
                    }
                }
            }
        }
        else {
            if (selElements && selElements.length) {
                Array.from(selElements).forEach((elem) => {
                    elem.classList.remove("selected-item");
                });
            }
            setSelectedData(null);
            setSelectedTabConfig("1");
        }
    }


    const content = renderData(genModel);

    console.debug(errors);
    console.debug(getValues());


    //Check object complexity
    var manageBackInput = false, manageBackTitle = false, manageBackIcon = false, manageWidth = false,
        manageMaxWidth = false, manageHeight = false, manageSpacing = false, manageAlignment = false, manageGroupOthers = false;

    var initCustomDesign = (cfgData, path, extraKey) => {
        if (!cfgData.customDesign) cfgData.customDesign = {};
        if (extraKey) {
            if (!cfgData.customDesign.extrasDesign) cfgData.customDesign.extrasDesign = {};
            if (!cfgData.customDesign.extrasDesign[extraKey]) cfgData.customDesign.extrasDesign[extraKey] = {};
            return cfgData.customDesign.extrasDesign[extraKey];
        }
        else {
            if (!cfgData.customDesign[path]) cfgData.customDesign[path] = {};
            return cfgData.customDesign[path];
        }
    };


    var listOptions = {
        back: (cfgData, path, keys, altValue) => {
            //TODO : backColor : manage color/icon/draw/http/path
            var pathStart = "editor." + cfgData.objType + "." + path;
            var labelI18n = t(pathStart + "back");
            var useBack = true, useBorder = true, useSize = true, useRadius = true, excludeImage = false;
            if (keys) {
                useBack = keys.indexOf("back") >= 0;
                excludeImage = keys.indexOf("noImage") >= 0;
                useBorder = keys.indexOf("border") >= 0;
                useSize = keys.indexOf("size") >= 0;
                useRadius = keys.indexOf("radius") >= 0;
            }

            var srcData = cfgData.customDesign ? cfgData.customDesign[path] : null;
            var extraKey;
            if (path.startsWith("extrasDesign")) {
                extraKey = path.replace("extrasDesign.", "");
                srcData = (cfgData.customDesign?.extrasDesign ? (cfgData.customDesign.extrasDesign[extraKey] || {}) : {});
            }
            if (altValue) srcData = cfgData[altValue];

            return <div className="mt-3">
                <Label for={"inputCfg" + path}>
                    {labelI18n !== (pathStart + "back") ? labelI18n : t("editor." + path + "back")}
                </Label>
                {useBack ? <FormGroup className="mb-0">
                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + srcData?.backColor?.replace("transparent", "#00FFFFFF").slice(3)} onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        editObj.backColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                        if (altValue) cfgData[altValue].backColor = editObj.backColor;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} style={{ width: "50px" }} />
                    <Label className="ms-2">{t(pathStart + "backcolor") !== (pathStart + "backcolor") ? t(pathStart + "backcolor") : t("editor." + path + "backcolor")}</Label>
                    {!excludeImage ? <>
                        <CImageSelector className="mt-0" files={appProps?.getSite()?.files} currentPath={() => {
                            if (srcData?.backColor?.startsWith("#")) return "";
                            else return (srcData?.backColor || "");
                        }} withSystemFiles={true} onChange={(imageObj) => {
                            if (imageObj) {
                                var editObj = initCustomDesign(cfgData, path, extraKey);

                                if (imageObj.name === "NONE") {
                                    editObj.backColor = "";
                                }
                                else {
                                    if (imageObj.isSystem) {

                                        //TEMP PATCH : supprime l'extension pour compatibilité android
                                        var splitName = imageObj.name.split(".");
                                        splitName.pop();
                                        imageObj.name = splitName.join(".");

                                        editObj.backColor = "draw:" + imageObj.name;
                                    }
                                    else {
                                        editObj.backColor = "/" + imageObj.name;
                                    }
                                }
                                if (altValue) cfgData[altValue].backColor = editObj.backColor;

                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }
                        }} />
                        {!srcData?.backColor?.startsWith("#") ? <FormGroup className="mb-0">
                            <Label className="d-none" for={"rangeCfg" + path}>{t(pathStart + "alpha") !== (pathStart + "alpha") ? t(pathStart + "alpha") : t("editor." + path + "alpha")}</Label>
                            <Input id={"rangeCfg" + path} type="range" value={(parseFloat(srcData?.alpha) * 100) || 0} onChange={(event) => {
                                var editObj = initCustomDesign(cfgData, path, extraKey);

                                var alphaChange = (event.target.value / 100);
                                editObj.alpha = (alphaChange >= 0.01 ? alphaChange?.toString() : "");
                                if (altValue) cfgData[altValue].alpha = cfgData.customDesign[path].alpha;
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                        </FormGroup> : ""}
                    </> : ""}
                </FormGroup> : ""}
                {useBorder ? <FormGroup className="mb-0">
                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + srcData?.borderColor?.replace("transparent", "#00FFFFFF").slice(3)} onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        editObj.borderColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                        if (altValue) cfgData[altValue].borderColor = editObj.borderColor;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} style={{ width: "50px" }} />
                    <Label className="ms-2">{t(pathStart + "bordercolor") !== (pathStart + "bordercolor") ? t(pathStart + "bordercolor") : t("editor." + path + "bordercolor")}</Label>
                </FormGroup> : ""}

                {useSize ? <div>
                    <Label className="">{t(pathStart + "bordersize") !== (pathStart + "bordersize") ? t(pathStart + "bordersize") : t("editor." + path + "bordersize")}</Label>
                    <FormGroup className="mb-0">
                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(srcData?.borderSize?.replace("px", "") || "0")} onChange={(event) => {
                            var editObj = initCustomDesign(cfgData, path, extraKey);

                            editObj.borderSize = event.target.value + "px";
                            if (altValue) cfgData[altValue].borderSize = editObj.borderSize;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} style={{ width: "50px" }} />
                        <Label className="ms-2">px</Label>
                    </FormGroup>
                </div> : ""}

                {useRadius ? <div>
                    <Label className="">{t(pathStart + "borderradius") !== (pathStart + "borderradius") ? t(pathStart + "borderradius") : t("editor." + path + "borderradius")}</Label>
                    <div>
                        <div className={`form-check-radio fcheck-sm d-inline-block me-3`}>
                            <Label check >
                                <Input id={`radio_val` + path} name={"radio" + path} defaultChecked={true} type="radio" value={"1"} onChange={(e) => {
                                    var value = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);

                                }} />
                                <span className="form-check-sign" />
                                {t("editor.radiusValue")}
                            </Label>
                        </div>
                        <div className={`form-check-radio fcheck-sm d-inline-block`}>
                            <Label check >
                                <Input id={`radio_pct` + path} name={"radio" + path} defaultChecked={false} type="radio" value={"2"} onChange={(e) => {
                                    var value = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);

                                }} />
                                <span className="form-check-sign" />
                                {t("editor.radiusPct")}
                            </Label>
                        </div>
                    </div>
                    <FormGroup className="mb-0">
                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(srcData?.borderRadius?.replace("px", "") || "0")} onChange={(event) => {
                            var editObj = initCustomDesign(cfgData, path, extraKey);

                            editObj.borderRadius = event.target.value + "px";
                            if (altValue) cfgData[altValue].borderRadius = editObj.borderRadius;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} style={{ width: "100px" }} />
                        <Label className="ms-2">px</Label>
                    </FormGroup>
                    <FormGroup className="mb-0">
                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" min="0" max="50" value={(srcData?.borderRadius?.replace("%", "") || "0")} onChange={(event) => {
                            var editObj = initCustomDesign(cfgData, path, extraKey);

                            editObj.borderRadius = event.target.value + "%";
                            if (altValue) cfgData[altValue].borderRadius = editObj.borderRadius;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} style={{ width: "100px" }} />
                        <Label className="ms-2">%</Label>
                    </FormGroup>
                </div> : ""}
            </div>;
        },
        font: (cfgData, path, keys, withUnderline, altValue) => {
            var pathStart = "editor." + cfgData.objType + "." + path;
            var labelI18n = t(pathStart + "font");
            var useColor = true, useSize = true, useStyle = true;
            if (keys) {
                useColor = keys.indexOf("color") >= 0;
                useSize = keys.indexOf("size") >= 0;
                useStyle = keys.indexOf("style") >= 0;
            }

            var srcData = cfgData.customDesign ? cfgData.customDesign[path] : null;
            var extraKey;
            if (path.startsWith("extrasDesign")) {
                extraKey = path.replace("extrasDesign.", "");
                srcData = (cfgData.customDesign?.extrasDesign ? (cfgData.customDesign.extrasDesign[extraKey] || {}) : {});
            }
            if (altValue) srcData = cfgData[altValue];

            return <div className="mt-3">
                <Label for={"inputCfg" + path}>
                    {labelI18n !== (pathStart + "font") ? labelI18n : t("editor." + path + "font")}
                </Label>
                {useColor ? <FormGroup className="mb-0">
                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + srcData?.fontColor?.replace("transparent", "#00FFFFFF").slice(3)} onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        editObj.fontColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                        if (altValue) cfgData[altValue].fontColor = editObj.fontColor;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} style={{ width: "50px" }} />
                    <Label className="ms-2">{t(pathStart + "fontcolor") !== (pathStart + "fontcolor") ? t(pathStart + "fontcolor") : t("editor." + path + "fontcolor")}</Label>
                </FormGroup> : ""}

                {useSize ? <div>
                    <Label className="">{t(pathStart + "fontsize") !== (pathStart + "fontsize") ? t(pathStart + "fontsize") : t("editor." + path + "fontsize")}</Label>
                    <FormGroup className="mb-0">
                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(srcData?.fontSize?.replace("px", "") || "0")} onChange={(event) => {
                            var editObj = initCustomDesign(cfgData, path, extraKey);

                            editObj.fontSize = event.target.value + "px";
                            if (altValue) cfgData[altValue].fontSize = editObj.fontSize;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} style={{ width: "100px" }} />
                        <Label className="ms-2">px</Label>
                    </FormGroup>
                </div> : ""}
                {useStyle ? <FormGroup className="mb-0">
                    <Label className="">{t(pathStart + "fontstyle") !== (pathStart + "fontstyle") ? t(pathStart + "fontstyle") : t("editor." + path + "fontstyle")}</Label>
                    <Input type="select" value={(srcData?.fontStyle || "")} onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        editObj.fontStyle = event.target.value;
                        if (altValue) cfgData[altValue].fontStyle = editObj.fontStyle;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }}>
                        <option className="" value={""}>Aucun</option>
                        <option className="" value="italic">Italique</option>
                        <option className="" value="bold">Gras</option>
                        {withUnderline ? <option className="" value="underline">Souligné</option> : ""}
                        <option className="" value="bold;italic">Gras/Italique</option>
                    </Input>
                </FormGroup> : ""}
            </div>;
        },
        boxSize: (cfgData, path, onOffMode, altValue) => {
            var srcData = cfgData.customDesign ? cfgData.customDesign[path] : null;
            var extraKey;
            if (path.startsWith("extrasDesign")) {
                extraKey = path.replace("extrasDesign.", "");
                srcData = (cfgData.customDesign?.extrasDesign ? (cfgData.customDesign.extrasDesign[extraKey] || {}) : {});
            }
            if (altValue) srcData = cfgData[altValue];
            var boxSize = srcData?.boxSize || 0;
            console.debug(boxSize);
            return onOffMode ? <FormGroup check className='text-start fcheck-sm'>
                    <Label check>
                    <Input checked={boxSize === "1" ? true : false} type="checkbox" onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        editObj.boxSize = event.target.checked ? "1" : "0";
                        if (altValue) cfgData[altValue].boxSize = editObj.boxSize;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} />
                        <span className="form-check-sign" />
                        {t("editor.weightOnOff")}
                    </Label>
                </FormGroup>
                : <><FormGroup className="mb-0">
                    <Label for={"rangeCfg" + path}>
                        {t("editor.weight")}
                    </Label>
                    <Input id={"rangeCfg" + path} type="range" value={(parseFloat(boxSize) * 100) || 0} onChange={(event) => {
                        var editObj = initCustomDesign(cfgData, path, extraKey);

                        var boxSizeChange = (event.target.value / 100);
                        editObj.boxSize = (boxSizeChange >= 0.01 ? boxSizeChange?.toString() : "");
                        if (altValue) cfgData[altValue].boxSize = editObj.boxSize;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} />
                    </FormGroup>
                    <ButtonGroup>
                        <Button className="disabled py-2 px-0" style={{width:"50px"}}><i className="fa fa-arrows-left-right-to-line"></i></Button>
                        <Button className="disabled py-2 px-0" style={{width:"50px"}}><i className="fa fa-arrow-right m-0"></i><i className="fa fa-square m-0"></i><i className="fa fa-arrow-left m-0"></i></Button>
                    </ButtonGroup>
                </>;
        },
        input: (cfgData, path, altValue) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "input";
            var labelI18n = t(labelStart);
            var inputValue;
            if (altValue) {
                var keyName = path.split(".");
                inputValue = (cfgData[altValue] ? (cfgData[altValue][keyName[keyName.length - 1]] || "") : "");
            }
            else inputValue = (cfgData[path] !== undefined ? cfgData[path] : "");
            return <FormGroup className="mb-0">
                <Label for={"inputCfg" + path}>
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "input")}
                </Label>
                <Input id={"inputCfg" + path} type="text" value={inputValue} onChange={(event) => {
                    //cfgData[path] = event.target.value;
                    commonFunc.setValue(cfgData, path, event.target.value);
                    if (altValue && cfgData[altValue]) {
                        var keyName = path.split(".");
                        cfgData[altValue][keyName[keyName.length - 1]] = cfgData[path];
                    }
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }} />
            </FormGroup>;
        },
        inputPx: (cfgData, path, altValue) => {
            var cleanI18nPath = path.replace(/\./g, "-").replace("customDesign-", "");
            var labelStart = "editor." + cfgData.objType + "." + cleanI18nPath + "inputPx";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path);
            if (altValue) {
                var keyName = path.split(".");
                srcValue = (cfgData[altValue] ? (cfgData[altValue][keyName[keyName.length - 1]] || "") : "");
            }
            var inputValue = (srcValue ? srcValue.replace("px", "") : "0");
            return <FormGroup className="mb-0">
                <Label for={"inputPxCfg" + path}>
                    {labelI18n !== labelStart ? labelI18n : t("editor." + cleanI18nPath + "inputPx")}
                </Label>
                <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={inputValue} onChange={(event) => {
                    //cfgData[path] = event.target.value + "px";
                    var valueInput = event.target.value + "px";
                    commonFunc.setValue(cfgData, path, valueInput);
                    if (altValue && cfgData[altValue]) {
                        var keyName = path.split(".");
                        cfgData[altValue][keyName[keyName.length - 1]] = valueInput;
                    }
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }} style={{ width: "100px" }} />
                <Label className="ms-2">px</Label>
            </FormGroup>;
        },
        checkbox: (cfgData, path, defaultValue, outValue, altValue) => {
            var cleanI18nPath = path.replace(/\./g, "-").replace("customDesign-", "");
            var labelStart = "editor." + cfgData.objType + "." + cleanI18nPath + "checkbox";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path);
            if (altValue) {
                var keyName = path.split(".");
                srcValue = (cfgData[altValue] ? (cfgData[altValue][keyName[keyName.length - 1]] || "") : "");
            }
            var inputValue = (srcValue !== undefined ? srcValue : (defaultValue ? true : false));
            if (outValue) inputValue = (srcValue === outValue);
            return <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                <Label check for={"checkconfig" + path} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                    <div className={`d-inline-block`}>
                        <Input type="checkbox" id={"checkconfig" + path} checked={inputValue} onChange={(event) => {
                            //cfgData[path] = (outValue ? (event.target.checked ? outValue : "") : event.target.checked);
                            var valueChecked = (outValue ? (event.target.checked ? outValue : "") : event.target.checked);
                            commonFunc.setValue(cfgData, path, valueChecked);
                            if (altValue && cfgData[altValue]) {
                                var keyName = path.split(".");
                                cfgData[altValue][keyName[keyName.length - 1]] = valueChecked;
                            }
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} />
                        <span className={`form-check-sign`} />
                        <div className={`d-inline-block ms-4`}>{labelI18n !== labelStart ? labelI18n : t("editor." + cleanI18nPath + "checkbox")}</div>
                    </div>
                </Label>
            </div>;
        },
        formatSelection: (cfgData, path, altValue) => {
            var cleanI18nPath = path.replace(/\./g, "-").replace("customDesign-", "");
            var labelStart = "editor." + cfgData.objType + "." + cleanI18nPath + "format";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path);
            if (altValue) {
                var keyName = path.split(".");
                srcValue = (cfgData[altValue] ? (cfgData[altValue][keyName[keyName.length - 1]] || "") : "");
            }
            var inputValue = (srcValue !== undefined ? srcValue : "");
            return <FormGroup className="mb-0">
                <Label for={"formatCfg" + path}>
                    {labelI18n !== labelStart ? labelI18n : t("editor." + cleanI18nPath + "format")}
                </Label>
                <Input id={"formatCfg" + path} type="select" value={inputValue} onChange={(event) => {
                    //cfgData[path] = event.target.value;
                    commonFunc.setValue(cfgData, path, event.target.value);
                    if (altValue && cfgData[altValue]) {
                        var keyName = path.split(".")
                        cfgData[altValue][keyName[keyName.length - 1]] = event.target.value;
                    }
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }}>
                    {(cfgData.objType === "picture") ? "" : <option className="" value={null}>Aucun</option>}
                    {cfgData.objType === "picture" ? <>
                        <option className="" value="png">PNG</option>
                        <option className="" value="jpg">JPG</option>
                        <option className="" value="jpeg">JPEG</option>
                        <option className="" value="b64">B64</option>
                        <option className="" value="b64j">B64 JPG</option>
                    </> : ""}
                    {cfgData.objType === "image" ? <>
                        <option className="" value={0}>Taille du composant</option>
                        <option className="" value={1}>Automatique</option>
                        <option className="" value={2}>Redimensionnée</option>
                        <option className="" value={100} >100px</option>
                        <option className="" value={200} >200px</option>
                        <option className="" value={500} >500px</option>
                    </> : ""}
                </Input>
            </FormGroup>;
        },
        subType: (cfgData, path, altValue) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "subType";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path);
            if (altValue) {
                var keyName = path.split(".");
                srcValue = (cfgData[altValue] ? (cfgData[altValue][keyName[keyName.length - 1]] || "") : "");
            }
            var inputValue = (srcValue !== undefined ? srcValue : "");
            return <FormGroup className="mb-0">
                <Label for={"subTypeCfg" + path} >
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "subType")}
                </Label>
                <Input id={"subTypeCfg" + path} type="select" value={inputValue} onChange={(event) => {
                    //cfgData[path] = event.target.value;
                    commonFunc.setValue(cfgData, path, event.target.value);
                    if (altValue && cfgData[altValue]) {
                        var keyName = path.split(".")
                        cfgData[altValue][keyName[keyName.length - 1]] = event.target.value;
                    }
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }}>
                    {(cfgData.objType === "canvas") ? "" : <option className="" value={null}>Aucun</option>}
                    {(() => {
                        var type = ["group", "itemsContainer"];
                        if (type.indexOf(cfgData.objType) >= 0) {
                            return (<>
                                <option className="" value="linear">Linéaire</option>
                                <option className="" value="linearVertical">Vertical</option>
                                <option className="" value="spreadInside">Séparé</option>
                                <option className="" value="packed">Paqueté</option>
                                <option className="" value="floating">Flottant (WEB)</option>
                            </>);
                        }
                        else {
                            return "";
                        }
                    })()}
                    {cfgData.objType === "text" ? <>
                        <option className="" value="text_1">1 ligne</option>
                        <option className="" value="text_5">Multi-lignes</option>
                        <option className="" value="text_5_html">Multi-lignes (HTML)</option>
                        <option className="" value="password">Mot de passe</option>
                        <option className="" value="email">Email</option>
                        <option className="" value="mail">Email</option>
                        <option className="" value="phone">Téléphone</option>
                        <option className="" value="integer">Entier</option>
                        <option className="" value="float">Décimal</option>
                        <option className="" value="datetime">Date/Heure</option>
                        <option className="" value="date_instant">Date instantanée</option>
                        <option className="" value="dateonly">Date</option>
                        <option className="" value="date">Date</option>
                        <option className="" value="time_instant">Heure instantanée</option>
                        <option className="" value="time">Heure</option>
                    </> : "" }
                    {(() => {
                        var type = ["textview"];
                        if (type.indexOf(cfgData.objType) >= 0)
                            return (<>
                                <option className="" value="divider">Séparateur</option>
                                <option className="" value="divider-dashed">Séparateur (pointillé) (WEB)</option>
                                <option className="" value="badge">Badge (WEB)</option>
                                <option className="" value="integer">Entier (WEB)</option><option className="" value="float">Décimal (WEB)</option>
                            </>);
                        else return "";
                    })()}
                    {(() => {
                        var type = ["collapsable"];
                        if (type.indexOf(cfgData.objType) >= 0) return (<option className="" value="divider">Séparateur</option>);
                        else return "";
                    })()}
                    {(() => {
                        var type = ["select", "dropdown"];
                        if (type.indexOf(cfgData.objType) >= 0)
                            return (<>
                                <option className="" value="integer">Entier (WEB)</option><option className="" value="float">Décimal (WEB)</option>
                                <option className="" value="multiple">Multiple (WEB)</option>
                                <option className="" value="create">Création (WEB)</option>
                                <option className="" value="multiplecreate">Multiple/Création (WEB)</option>
                            </>);
                        else return "";
                    })()}
                    {(() => {// TODO /!\ Utilisation WEB de subType pour DLG_REPORTS >> voir pour dépendre plutot des onClick
                        if (cfgData.objType === "button") return (<option className="" value="submit">Envoi</option>);
                        else return "";
                    })()}
                    {cfgData.objType === "checkbox" ? <><option className="" value="integer">Entier</option><option className="" value="float">Décimal</option></> : ""}
                    {cfgData.objType === "finder" ? <><option className="" value="text">Texte</option><option className="" value="integer">Entier</option><option className="" value="float">Décimal</option></> : ""}
                    {cfgData.objType === "progressbar" ? <><option className="" value="integer">Entier</option><option className="" value="float">Décimal</option><option className="" value="passwordStrength">Force Mot de passe</option></> : ""}
                    {cfgData.objType === "radio" ? <><option className="" value="integer">Entier (WEB)</option><option className="" value="float">Décimal (WEB)</option><option className="" value="boolean">Booléen</option></> : ""}
                    {(() => {
                        if (cfgData.objType === "picture")
                            return (<>
                                <option className="" value="detailed">Détaillé</option>
                                <option className="" value="lock">Verrouillé</option>
                            </>);
                        else return "";
                    })()}
                    {(() => {
                        if (cfgData.objType === "canvas")
                            return (<>
                                <option className="" value="b64j">b64j</option>
                                <option className="" value="b64">b64</option>
                                <option className="" value="png">png</option>
                                <option className="" value="jpg">jpg</option>
                                <option className="" value="jpeg">jpeg</option>
                            </>);
                        else return "";
                    })()}
                    {cfgData.objType === "dropdown" ? <option className="" value="rawValue">Texte Brut</option> : ""}
                    {cfgData.objType === "simpleList" ? <option className="" value="custom">Custom (rattachement i18n / sert aux clés primaire/secondaire)</option> : ""/*TODO*/}
                    {cfgData.objType === "widgetList" ? <option className="" value="custom">Custom (rattachement i18n / sert aux clés primaire/secondaire)</option> : ""/*TODO*/}
                    {cfgData.objType === "chart" ? <option className="" value="chartjs">Check ChartJS</option> : ""/*TODO*/}
                    {cfgData.objType === "planning" ? <option className="" value="external">Externe</option> : ""}

                    <option className="d-none" value="info">Old Button</option>
                    <option className="d-none" value="openFile">Old Button</option>
                    <option className="d-none" value="plan">AAD???</option>
                    <option className="d-none" value="planning">Planning</option>
                    <option className="d-none" value="ignore">Ignore</option>
                    <option className="d-none" value="table">Table</option>
                    <option className="d-none" value="list">Liste</option>
                </Input>
            </FormGroup>;
        },
        manageRights: (cfgData, path) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "rights";
            var labelI18n = t(labelStart);
            var inputValue = (cfgData.checkRights?.entity || "");
            return <FormGroup className="mb-0 border border-dark p-2">
                <Label for={"inputCfg" + path}>
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "rights")}
                </Label>
                <Input id={"inputCfg" + path} type="text" value={inputValue} onChange={(event) => {
                    if (!cfgData.checkRights) cfgData.checkRights = {};
                    cfgData.checkRights.entity = event.target.value;
                    //cfgData.functionManager.rerender();
                    //setRerender(!rerender);
                }} />
                <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                    <Label check for={"rightscreate"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                        <div className={`d-inline-block`}>
                            <Input type="checkbox" id={"rightscreate"} checked={cfgData.checkRights?.rights?.indexOf("C") >= 0} onChange={(event) => {
                                if (event.target.checked) {
                                    if (!cfgData.checkRights) cfgData.checkRights = {};
                                    if (!cfgData.checkRights.rights) cfgData.checkRights.rights = "";
                                    if (cfgData.checkRights?.rights?.indexOf("C") < 0) cfgData.checkRights.rights += "C";
                                }
                                else {
                                    cfgData.checkRights.rights = cfgData.checkRights.rights.replace("C", "");
                                }
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                            <span className={`form-check-sign`} />
                            <div className={`d-inline-block ms-4`}>{t("editor.rightscreate")}</div>
                        </div>
                    </Label>
                </div>
                <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                    <Label check for={"rightsread"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                        <div className={`d-inline-block`}>
                            <Input type="checkbox" id={"rightsread"} checked={cfgData.checkRights?.rights?.indexOf("R") >= 0} onChange={(event) => {
                                if (event.target.checked) {
                                    if (!cfgData.checkRights) cfgData.checkRights = {};
                                    if (!cfgData.checkRights.rights) cfgData.checkRights.rights = "";
                                    if (cfgData.checkRights?.rights?.indexOf("R") < 0) cfgData.checkRights.rights += "R";
                                }
                                else {
                                    cfgData.checkRights.rights = cfgData.checkRights.rights.replace("R", "");
                                }
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                            <span className={`form-check-sign`} />
                            <div className={`d-inline-block ms-4`}>{t("editor.rightsread")}</div>
                        </div>
                    </Label>
                </div>
                <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                    <Label check for={"rightsupdate"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                        <div className={`d-inline-block`}>
                            <Input type="checkbox" id={"rightsupdate"} checked={cfgData.checkRights?.rights?.indexOf("U") >= 0} onChange={(event) => {
                                if (event.target.checked) {
                                    if (!cfgData.checkRights) cfgData.checkRights = {};
                                    if (!cfgData.checkRights.rights) cfgData.checkRights.rights = "";
                                    if (cfgData.checkRights?.rights?.indexOf("U") < 0) cfgData.checkRights.rights += "U";
                                }
                                else {
                                    cfgData.checkRights.rights = cfgData.checkRights.rights.replace("U", "");
                                }
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                            <span className={`form-check-sign`} />
                            <div className={`d-inline-block ms-4`}>{t("editor.rightsupdate")}</div>
                        </div>
                    </Label>
                </div>
                <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                    <Label check for={"rightsdelete"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                        <div className={`d-inline-block`}>
                            <Input type="checkbox" id={"rightsdelete"} checked={cfgData.checkRights?.rights?.indexOf("D") >= 0} onChange={(event) => {
                                if (event.target.checked) {
                                    if (!cfgData.checkRights) cfgData.checkRights = {};
                                    if (!cfgData.checkRights.rights) cfgData.checkRights.rights = "";
                                    if (cfgData.checkRights?.rights?.indexOf("D") < 0) cfgData.checkRights.rights += "D";
                                }
                                else {
                                    cfgData.checkRights.rights = cfgData.checkRights.rights.replace("D", "");
                                }
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                            <span className={`form-check-sign`} />
                            <div className={`d-inline-block ms-4`}>{t("editor.rightsdelete")}</div>
                        </div>
                    </Label>
                </div>
                <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                    <Label check for={"rightslist"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                        <div className={`d-inline-block`}>
                            <Input type="checkbox" id={"rightslist"} checked={cfgData.checkRights?.rights?.indexOf("L") >= 0} onChange={(event) => {
                                if (event.target.checked) {
                                    if (!cfgData.checkRights) cfgData.checkRights = {};
                                    if (!cfgData.checkRights.rights) cfgData.checkRights.rights = "";
                                    if (cfgData.checkRights?.rights?.indexOf("L") < 0) cfgData.checkRights.rights += "L";
                                }
                                else {
                                    cfgData.checkRights.rights = cfgData.checkRights.rights.replace("L", "");
                                }
                                cfgData.functionManager.rerender();
                                setRerender(!rerender);
                            }} />
                            <span className={`form-check-sign`} />
                            <div className={`d-inline-block ms-4`}>{t("editor.rightslist")}</div>
                        </div>
                    </Label>
                </div>
            </FormGroup>;
        },
        manageArguments: (cfgData, path) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "args";
            var labelI18n = t(labelStart);
            if (typeof cfgData.arguments == "string") {
                cfgData.arguments = JSON.parse(cfgData.arguments);
            }

            return <FormGroup className="mb-0">
                <Label for="">
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "args")}
                </Label>
                {cfgData.arguments ? Object.keys(cfgData.arguments).map((key) => {
                    var argsVal = cfgData.arguments[key];
                    return (<div className="d-flex">
                        <div className="col-4 me-1"><Input type="text" value={key} onChange={(event) => {
                            var currVal = event.target.value;
                            var srcVal = cfgData.arguments[key];
                            if (cfgData.arguments[currVal]) currVal = currVal + "C";
                            delete cfgData.arguments[key];
                            cfgData.arguments[currVal] = srcVal;
                            cfgData.argumentsObj = cfgData.arguments;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} /></div>
                        <div className="col-8"><Input type="text" value={argsVal} onChange={(event) => {
                            cfgData.arguments[key] = event.target.value;
                            cfgData.functionManager.rerender();
                            setRerender(!rerender);
                        }} /></div>
                    </div>);
                }) : ""}
                
                <Button className="btn-icon d-block" color="primary" onClick={(event) => {
                    if (!cfgData.arguments) cfgData.arguments = {};
                    cfgData.arguments["newArgs"] = "";
                    cfgData.argumentsObj = cfgData.arguments;
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }}><i className="fa fa-plus"></i></Button>
            </FormGroup>;
        },
        manageEvents: (cfgData, path) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "events";
            var labelI18n = t(labelStart);
            return <FormGroup className="mb-0">
                <Label for="">
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "events")}
                </Label>
                {cfgData.onActionEvents ? Object.keys(cfgData.onActionEvents).sort().map((key, index) => {
                    var argsVal = cfgData.onActionEvents[key];
                    console.debug(argsVal);
                    if (argsVal && argsVal.length) {
                        return <div key={"eventType" + index}>
                            {argsVal.map((triggerObj) => {
                                if (!triggerObj.key) triggerObj.key = Math.floor(Math.random() * 1000000000);
                                console.debug(triggerObj.key);
                                return (<div key={triggerObj.key} className="row my-1">
                                    <div className="col-2">
                                        <Button className="btn-icon m-0" color="danger" onClick={(event) => {
                                            cfgData.onActionEvents[key] = cfgData.onActionEvents[key].filter(item => item !== triggerObj);
                                            setRerender(!rerender);
                                        }}><i className="fa fa-trash"></i></Button>
                                    </div>
                                    <div className="col-4">
                                        <Input type="select" value={key} onChange={(event) => {
                                            //cfgData.onActionEvents[key].remove(triggerObj);
                                            cfgData.onActionEvents[key] = cfgData.onActionEvents[key].filter(item => item !== triggerObj);
                                            if (!cfgData.onActionEvents[event.target.value]) cfgData.onActionEvents[event.target.value] = [];
                                            cfgData.onActionEvents[event.target.value].push(triggerObj);
                                            //cfgData.functionManager.rerender();
                                            setRerender(!rerender);
                                        }}>
                                            <option className="" value="onClick">onClick</option>
                                            <option className="" value="onLoad">onLoad</option>
                                            <option className="" value="onChange">onChange</option>
                                            <option className="" value="onRefresh">onRefresh</option>
                                        </Input>
                                    </div>
                                    <div className="col-6 d-flex ps-0">
                                        <Label className="text-nowrap align-content-center m-0 me-1" for="">
                                            {t("editor.labeltrigger" + path)}
                                        </Label>
                                        <Input type="text" value={triggerObj.trigger} onChange={(event) => {
                                            triggerObj.trigger = event.target.value;
                                            //cfgData.functionManager.rerender();
                                            setRerender(!rerender);
                                        }} />
                                    </div>
                                    <div className="col-12 d-flex mt-1">
                                        <Label className="col-3 text-nowrap align-content-center m-0 me-1" for="">
                                            {t("editor.labeltarget" + path)}
                                        </Label>
                                        <Input type="text" value={triggerObj.target} onChange={(event) => {
                                            triggerObj.target = event.target.value;
                                            //cfgData.functionManager.rerender();
                                            setRerender(!rerender);
                                        }} />
                                    </div>
                                    <div className="col-12 d-flex mt-1">
                                        <Label className="col-3 text-nowrap align-content-center m-0 me-1" for="">
                                            {t("editor.labelvalue" + path)}
                                        </Label>
                                        <Input type="text" value={triggerObj.value} onChange={(event) => {
                                            triggerObj.value = event.target.value;
                                            //cfgData.functionManager.rerender();
                                            setRerender(!rerender);
                                        }} />
                                    </div>
                                </div>);
                            })}
                        </div>;
                    }
                    else return ""
                }) : ""}

                <Button className="btn-icon d-block" color="primary" onClick={(event) => {
                    if (!cfgData.onActionEvents) cfgData.onActionEvents = {};
                    if (!cfgData.onActionEvents["onLoad"]) cfgData.onActionEvents["onLoad"] = [];
                    cfgData.onActionEvents["onLoad"].push({ trigger: "", value: "" });
                    cfgData.functionManager.rerender();
                    setRerender(!rerender);
                }}><i className="fa fa-plus"></i></Button>
            </FormGroup>;
        },
        icon: () => "",
        alignment: (cfgData, path, altValue) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "align";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path);
            if (altValue) srcValue = cfgData[altValue];
            var onClick = (event, value) => {
                if (!cfgData[path]) cfgData[path] = {};
                cfgData[path].alignment = value;
                if (altValue) cfgData[altValue].alignment = value;
                cfgData.functionManager.rerender();
                setRerender(!rerender);
            };
            return <>
                <Label className="d-block" for="">
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "align")}
                </Label>
                <ButtonGroup>
                    <Button title="Aucun" color="dark" className={`btn-simple px-2 py-1 ${commonFunc.isBlank(srcValue?.alignment) ? "active" : ""}`} onClick={(event) => onClick(event, "")}><i className="fa fa-times m-0"></i></Button>
                    <Button title="Début" color="dark" className={`btn-simple px-2 py-1 ${srcValue?.alignment === "start" ? "active" : ""}`} onClick={(event) => onClick(event, "start")}><i className="fa fa-align-left m-0"></i></Button>
                    <Button title="Centre" color="dark" className={`btn-simple px-2 py-1 ${srcValue?.alignment === "center" ? "active" : ""}`} onClick={(event) => onClick(event, "center")}><i className="fa fa-align-center m-0"></i></Button>
                    <Button title="Fin" color="dark" className={`btn-simple px-2 py-1 ${srcValue?.alignment === "end" ? "active" : ""}`} onClick={(event) => onClick(event, "end")}><i className="fa fa-align-right m-0"></i></Button>
                </ButtonGroup>
            </>;
        },

        selectImage: (cfgData, path, manageTag) => {
            var labelStart = "editor." + cfgData.objType + "." + path + "image";
            var labelI18n = t(labelStart);
            var srcValue = commonFunc.getValue(cfgData, path) || "";
            return <>
                <Label className="d-block" for="">
                    {labelI18n !== labelStart ? labelI18n : t("editor." + path + "image")}
                </Label>
                <CImageSelector className="mt-0" files={appProps?.getSite()?.files} currentPath={srcValue} withSystemFiles={true} onChange={(imageObj) => {
                    if (imageObj) {
                        console.debug(imageObj);
                        if (imageObj.name === "NONE") {
                            if (manageTag) cfgData.tag = "";
                            commonFunc.setValue(cfgData, path, "");
                        }
                        else {
                            if (manageTag) cfgData.tag = imageObj.name;
                            if (imageObj.isSystem) {

                                //TEMP PATCH : supprime l'extension pour compatibilité android
                                var splitName = imageObj.name.split(".");
                                splitName.pop();
                                imageObj.name = splitName.join(".");

                                commonFunc.setValue(cfgData, path, "draw:" + imageObj.name);
                            }
                            else {
                                commonFunc.setValue(cfgData, path, "/" + imageObj.name);
                            }
                        }

                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }
                }} />
            </>;
        },

        padding: () => "",
        margin: () => "",
        maxWidth: () => "",
        position: () => "",

        childs: (cfgData) => <h6 className="fw-bold">{t("editor.childs")}</h6>,
        subTitle: (cfgData) => {
            var labelStart = "editor." + cfgData.objType + ".subTitle";
            var labelI18n = t(labelStart);
            //Recherche titre
            var titleCpt = null;
            if (cfgData.children) {
                var titleProc = (containerData) => {
                    var targetData = containerData || cfgData;
                    var filteredTitles = targetData.children.filter((subItem) => subItem.objType === "textview" && commonFunc.isBlank(subItem.bindPropResult) && !subItem.customDesign?.designIcon?.icon);
                    if (filteredTitles?.length) {
                        titleCpt = filteredTitles[0];
                    }
                    else {
                        var filteredContainers = targetData.children.filter((subItem) => subItem.objType === "itemsContainer");
                        if (filteredContainers?.length) {
                            filteredContainers.forEach((item) => {
                                titleProc(item);
                            });
                        }
                    }
                };
                titleProc();
            }
            var inputValue = titleCpt?.title || "";
            return titleCpt ? <>
                <FormGroup className="mb-0">
                    <Label for={"inputCfg" + 1}>
                        {labelI18n !== labelStart ? labelI18n : t("editor.subTitle")}
                    </Label>
                    <Input id={"inputCfg" + 1} type="text" value={inputValue} onChange={(event) => {
                        titleCpt.title = event.target.value;
                        titleCpt.functionManager.rerender();
                        setRerender(!rerender);
                    }} />
                </FormGroup>
            </> : "";
        },
        subIcon: (cfgData) => {
            var labelStart = "editor." + cfgData.objType + ".subIcon";
            var labelI18n = t(labelStart);
            //Recherche icone
            var icon = null;
            if (cfgData.children) {
                var iconProc = (containerData) => {
                    var targetData = containerData || cfgData;
                    var filteredIcons = targetData.children.filter((subItem) => subItem.objType === "textview" && subItem.customDesign?.designIcon?.icon);
                    if (filteredIcons?.length) {
                        icon = filteredIcons[0];
                    }
                    else {
                        var filteredContainers = targetData.children.filter((subItem) => subItem.objType === "itemsContainer");
                        if (filteredContainers?.length) {
                            filteredContainers.forEach((item) => {
                                iconProc(item);
                            });
                        }
                    }
                };
                iconProc();
            }
            var iconValue = icon?.mergedDesignIcon?.icon;//icon?.customDesign?.designIcon?.icon;
            return icon ? <>
                <Label className="d-block" for="">
                    {labelI18n !== labelStart ? labelI18n : t("editor.subIcon")}
                </Label>
                <Select isMulti={false} id={"select" + 1} className="" isDisabled={false} isSearchable={true} formatOptionLabel={(option, { context }) => {
                    return <><i className={`fa ${option.label.replace(/_/g, "-")} me-1`}></i>{option.label}</>;
                }} onChange={(e) => {
                    /*if (Array.isArray(e)) {
                        var values
                        if (data.propNameJsType === "array") {
                            values = e.map(v => v.value);
                        }
                        else {
                            values = e.map(v => v.value).join(";");
                        }
                        onChange(values);
                        setValue(bindPropResult, values);
                    }
                    else {
                        onChange(e.value);
                        setValue(bindPropResult, e.value);
                    }*/

                    icon.customDesign.designIcon.icon = e.value;

                    icon?.functionManager.rerender();
                    setRerender(!rerender);
                }} value={{ label: iconValue, value: iconValue }}
                    options={Icons.map(icon => { return { value: icon, label: icon }; })} />
            </> : "";
        },
        switchIcon: (cfgData) => {
            var labelStart = "editor." + cfgData.objType + ".switchIcon";
            var labelI18n = t(labelStart);
            //Recherche icone
            var parentIcon = null;
            var icon = null;
            var nextIcon = null;
            var iconFirst = false;
            if (cfgData.children) {
                var iconProc = (containerData) => {
                    var targetData = containerData || cfgData;
                    var filteredIcons = targetData.children.filter((subItem) => subItem.objType === "textview" && subItem.customDesign?.designIcon?.icon);
                    if (filteredIcons?.length && targetData.children.length === 2) {
                        parentIcon = targetData !== cfgData ? targetData : null;
                        icon = filteredIcons[0];
                        nextIcon = targetData.children[1];
                        iconFirst = targetData.children[0] === icon;
                    }
                    else {
                        var filteredContainers = targetData.children.filter((subItem) => subItem.objType === "itemsContainer");
                        if (filteredContainers?.length) {
                            filteredContainers.forEach((item) => {
                                iconProc(item);
                            });
                        }
                    }
                };
                iconProc();
            }
            return (icon && parentIcon) ? <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                <Label check for={"checkconfig" + 1} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                    <div className={`d-inline-block`}>
                        <Input type="checkbox" id={"checkconfig" + 1} checked={iconFirst} onChange={(event) => {
                            parentIcon.children = parentIcon.children.filter(child => child !== icon);
                            if (event.target.checked) {
                                parentIcon.children.unshift(icon);
                            }
                            else {
                                parentIcon.children.push(icon);
                            }

                            parentIcon.functionManager.rerender();
                            setRerender(!rerender);
                        }} />
                        <span className={`form-check-sign`} />
                        <div className={`d-inline-block ms-4`}>{labelI18n !== labelStart ? labelI18n : t("editor.switchIcon")}</div>
                    </div>
                </Label>
            </div> : "";
        }
    };
    var renderOptions = [];
    var styleOptions = [];
    var actionsOptions = [];
    if (selectedData) {
        console.debug(selectedData);
        renderOptions.push(listOptions["input"](selectedData, "bindPropResult"));
        renderOptions.push(listOptions["subType"](selectedData, "subType"));
        renderOptions.push(listOptions["checkbox"](selectedData, "hidden"));
        renderOptions.push(listOptions["checkbox"](selectedData, "disabled"));
        actionsOptions.push(listOptions["manageRights"](selectedData, "checkRights"));

        var useDefault = false;
        switch (selectedData.objType) {
            case "template":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", null, "mergedDesignInput"));
                styleOptions.push(listOptions["icon"](selectedData, "designInput"));
                //styleOptions.push(listOptions["boxSize"](selectedData, "design"));//Influence son parent en horizontal si renseigné

                renderOptions.push(listOptions["input"](selectedData, "title"));

                styleOptions.push(listOptions["padding"](selectedData, "design"));
                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1
                //TODO : childless/collapsable
                break;
            case "category":
            case "header":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designIcon", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));//TODO
                styleOptions.push(listOptions["font"](selectedData, "designIcon", null, null, "mergedDesignIcon"));
                styleOptions.push(listOptions["icon"](selectedData, "designIcon"));//TODO
                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));//Influence son parent en horizontal si renseigné

                renderOptions.push(listOptions["input"](selectedData, "title"));
                renderOptions.push(listOptions["checkbox"](selectedData, "childless"));
                renderOptions.push(listOptions["checkbox"](selectedData, "collapsable"));
                if (selectedData.collapsable) {
                    renderOptions.push(listOptions["checkbox"](selectedData, "defaultCollapsed"));
                }

                styleOptions.push(listOptions["margin"](selectedData, "design"));//TODO
                styleOptions.push(listOptions["margin"](selectedData, "designTitle"));
                styleOptions.push(listOptions["margin"](selectedData, "designIcon"));

                styleOptions.push(listOptions["padding"](selectedData, "design"));//TODO
                styleOptions.push(listOptions["padding"](selectedData, "designTitle"));
                styleOptions.push(listOptions["padding"](selectedData, "designIcon"));
                styleOptions.push(listOptions["padding"](selectedData, "designInput"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.elevation", "mergedDesignTitle"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.width", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.height", "mergedDesignTitle"));
                //TODO : childless/collapsable
                break;
            case "group":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["boxSize"](selectedData, "design", true, "mergedDesign"));
                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "design"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["maxWidth"](selectedData, "design"));

                styleOptions.push(listOptions["padding"](selectedData, "design", "start;top"));

                manageSpacing = true;
                manageGroupOthers = true;
                break;
            case "itemsContainer":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "design"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1

                if (!selectedData.subType?.startsWith("linear")) styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));
                manageSpacing = true;
                break;
            case "button":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));//TODO : Color >> backSecondColor pour dégradé
                styleOptions.push(listOptions["back"](selectedData, "extrasDesign.containerDesign"));
                styleOptions.push(listOptions["font"](selectedData, "design", null, null, "mergedDesign"));
                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));

                renderOptions.push(listOptions["input"](selectedData, "title"));


                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));
                styleOptions.push(listOptions["position"](selectedData, "design"));

                styleOptions.push(listOptions["alignment"](selectedData, "designTitle"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "designTitle"));

                actionsOptions.push(listOptions["manageArguments"](selectedData, "arguments"));

                if (selectedData.groupSubName?.startsWith("containerGroup")) {
                    renderOptions.push(listOptions["childs"](selectedData));
                    renderOptions.push(listOptions["subTitle"](selectedData));
                    renderOptions.push(listOptions["subIcon"](selectedData));
                    renderOptions.push(listOptions["switchIcon"](selectedData));
                }

                break;
            case "picture":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designIcon", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", null, "mergedDesignInput"));
                styleOptions.push(listOptions["font"](selectedData, "designIcon", "color;size", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["icon"](selectedData, "designIcon"));

                renderOptions.push(listOptions["formatSelection"](selectedData, "format"));

                styleOptions.push(listOptions["margin"](selectedData, "designIcon"));
                styleOptions.push(listOptions["padding"](selectedData, "designIcon"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designIcon.elevation", "mergedDesignIcon"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designIcon.width", "mergedDesignIcon"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designIcon.height", "mergedDesignIcon"));

                useDefault = true;
                break;
            case "text"://Date/time + float
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", null, "mergedDesignInput"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "designInput", null, null, "mergedDesignInput"));
                styleOptions.push(listOptions["alignment"](selectedData, "designInput", "mergedDesignInput"));
                styleOptions.push(listOptions["icon"](selectedData, "designInput"));

                renderOptions.push(listOptions["input"](selectedData, "format"));

                styleOptions.push(listOptions["margin"](selectedData, "designInput"));
                styleOptions.push(listOptions["margin"](selectedData, "designTitle"));

                renderOptions.push(listOptions["checkbox"](selectedData, "customDesign.designTitle.position", null, "floating", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));

                styleOptions.push(listOptions["boxSize"](selectedData, "designInput", true, "mergedDesignInput"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.width", "mergedDesignInput"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.height", "mergedDesignInput"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.width", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.height", "mergedDesignTitle"));

                useDefault = true;
                break;
            case "openFile":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["font"](selectedData, "design", null, null, "mergedDesign"));

                renderOptions.push(listOptions["input"](selectedData, "format"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "design"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));

                useDefault = true;
                break;
            case "textview"://date:HH:mm
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designIcon", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", "back", "mergedDesignInput"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, true, "mergedDesignTitle"));//+underline
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));//+underline
                styleOptions.push(listOptions["font"](selectedData, "designIcon", null, null, "mergedDesignIcon"));
                styleOptions.push(listOptions["icon"](selectedData, "designIcon"));
                styleOptions.push(listOptions["alignment"](selectedData, "designIcon", "mergedDesignIcon"));

                renderOptions.push(listOptions["input"](selectedData, "format"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["margin"](selectedData, "designTitle"));
                styleOptions.push(listOptions["margin"](selectedData, "designIcon"));
                styleOptions.push(listOptions["padding"](selectedData, "designIcon"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["maxWidth"](selectedData, "design"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.height", "mergedDesignInput"));

                useDefault = true;
                break;
            case "checkbox"://value OU "true"
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designIcon", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", "back", "mergedDesignInput"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "designIcon", "color;size", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["icon"](selectedData, "designIcon"));
                styleOptions.push(listOptions["font"](selectedData, "designInput", "color", null, "mergedDesignInput"));

                renderOptions.push(listOptions["input"](selectedData, "format"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "designTitle"));
                styleOptions.push(listOptions["padding"](selectedData, "designIcon"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.width", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.height", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designIcon.width", "mergedDesignIcon"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designIcon.height", "mergedDesignIcon"));

                useDefault = true;
                break;
            case "canvas"://value OU "true"
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["font"](selectedData, "design", "color;size", null, "mergedDesign"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "designIcon", "color;size", null, "mergedDesignIcon"));

                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));
                renderOptions.push(listOptions["input"](selectedData, "title"));
                actionsOptions.push(listOptions["manageArguments"](selectedData, "arguments"));
                break;

            case "collapsable":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designIcon", null, "mergedDesignIcon"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", "back", "mergedDesignInput"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, true, "mergedDesignTitle"));//+underline
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "designIcon", null, null, "mergedDesignIcon"));
                styleOptions.push(listOptions["icon"](selectedData, "designIcon"));
                styleOptions.push(listOptions["alignment"](selectedData, "designIcon", "mergedDesignIcon"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["margin"](selectedData, "designTitle"));
                styleOptions.push(listOptions["margin"](selectedData, "designIcon"));
                styleOptions.push(listOptions["padding"](selectedData, "designIcon"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.height", "mergedDesignInput"));

                //styleOptions.push(listOptions["back"](selectedData, "designIcon"));//TODO : extrasDesign.altDesign_icon
                //styleOptions.push(listOptions["font"](selectedData, "designIcon", null, null, "mergedDesignIcon"));//TODO : extrasDesign.altDesign_icon
                //styleOptions.push(listOptions["icon"](selectedData, "designIcon"));//TODO : extrasDesign.altDesign_icon
                //styleOptions.push(listOptions["alignment"](selectedData, "designIcon", "mergedDesignIcon"));//TODO : extrasDesign.altDesign_icon
                //styleOptions.push(listOptions["margin"](selectedData, "designIcon"));//TODO : extrasDesign.altDesign_icon
                //styleOptions.push(listOptions["padding"](selectedData, "designIcon"));//TODO : extrasDesign.altDesign_icon

                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));
                renderOptions.push(listOptions["input"](selectedData, "title"));
                renderOptions.push(listOptions["checkbox"](selectedData, "defaultValue"));
                actionsOptions.push(listOptions["manageArguments"](selectedData, "arguments"));
                break;

            case "select":
            case "dropdown":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["back"](selectedData, "designInput", null, "mergedDesignInput"));
                //styleOptions.push(listOptions["back"](selectedData, "design", "back"));//TODO : extrasDesign.popupDesign
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));
                //styleOptions.push(listOptions["back"](selectedData, "design"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["font"](selectedData, "design", null, null, "mergedDesign"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["icon"](selectedData, "design"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["back"](selectedData, "designIcon"));//TODO : options
                //styleOptions.push(listOptions["font"](selectedData, "designIcon", null, null, "mergedDesignIcon"));//TODO : options
                //styleOptions.push(listOptions["icon"](selectedData, "designIcon"));//TODO : options

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["margin"](selectedData, "designInput"));
                styleOptions.push(listOptions["margin"](selectedData, "designTitle"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));

                styleOptions.push(listOptions["icon"](selectedData, "designInput"));
                styleOptions.push(listOptions["boxSize"](selectedData, "designInput", null, "mergedDesignInput"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.width", "mergedDesignInput"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designInput.height", "mergedDesignInput"));
                styleOptions.push(listOptions["alignment"](selectedData, "designInput", "mergedDesignInput"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.width", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.height", "mergedDesignTitle"));

                useDefault = true;
                break;
            case "radio":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "designTitle", null, null, "mergedDesignTitle"));
                styleOptions.push(listOptions["alignment"](selectedData, "designTitle", "mergedDesignTitle"));

                styleOptions.push(listOptions["padding"](selectedData, "design"));
                styleOptions.push(listOptions["padding"](selectedData, "designTitle"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));//ECHO
                styleOptions.push(listOptions["alignment"](selectedData, "designInput", "mergedDesignInput"));//ECHO

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.width", "mergedDesignTitle"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.designTitle.height", "mergedDesignTitle"));

                useDefault = true;
                break;

            case "image":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                styleOptions.push(listOptions["back"](selectedData, "designTitle", null, "mergedDesignTitle"));
                styleOptions.push(listOptions["font"](selectedData, "design", null, null, "mergedDesign"));
                styleOptions.push(listOptions["alignment"](selectedData, "design", "mergedDesign"));

                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));

                renderOptions.push(listOptions["selectImage"](selectedData, "src", true));

                renderOptions.push(listOptions["formatSelection"](selectedData, "customDesign.design.size", "mergedDesign"));//TODO : check si besoin de parseInt

                useDefault = true;
                break;
            case "list":
                styleOptions.push(listOptions["back"](selectedData, "design", null, "mergedDesign"));
                //styleOptions.push(listOptions["back"](selectedData, "design"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["font"](selectedData, "design", "color", null, "mergedDesign"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["height"](selectedData, "design"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.elevation", "mergedDesign"));//TODO : extrasDesign.defaultItems
                //styleOptions.push(listOptions["padding"](selectedData, "design"));//TODO : extrasDesign.defaultItems
                styleOptions.push(listOptions["margin"](selectedData, "design"));

                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1

                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));
                actionsOptions.push(listOptions["manageArguments"](selectedData, "arguments"));
                break;


            /*case "contact":
                styleOptions.push(listOptions["back"](selectedData, "design"));
                styleOptions.push(listOptions["back"](selectedData, "designInput"));
                styleOptions.push(listOptions["font"](selectedData, "designInput", null, null, "mergedDesignInput"));
                
                styleOptions.push(listOptions["margin"](selectedData, "design"));
                styleOptions.push(listOptions["margin"](selectedData, "designInput"));
                styleOptions.push(listOptions["padding"](selectedData, "designInput"));
                //styleOptions.push(listOptions["font"](selectedData, "design", null, null, "mergedDesign"));//TODO : extrasDesign.contactLines
                //styleOptions.push(listOptions["padding"](selectedData, "design"));//TODO : extrasDesign.contactLines
                
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.width", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["inputPx"](selectedData, "customDesign.design.height", "mergedDesign"));//+ -1
                styleOptions.push(listOptions["maxWidth"](selectedData, "design"));

                useDefault = true;
                break;*/

            //case "planning":
            //case "tgFrag":
            //case "webFrag":


            default:
                useDefault = true;
                break;
        }
        if (useDefault) {
            if (!commonFunc.isBlank(selectedData?.objType)) {
                styleOptions.push(listOptions["boxSize"](selectedData, "design", null, "mergedDesign"));
            }
            renderOptions.push(listOptions["input"](selectedData, "title"));
            renderOptions.push(listOptions["input"](selectedData, "defaultValue"));

            actionsOptions.push(listOptions["manageArguments"](selectedData, "arguments"));
        }

        actionsOptions.push(listOptions["manageEvents"](selectedData, "events"));
    }
    else {

    }

    //TODO : rootModel (bindType / useZip / version / name / refId / modalVersion / syncLocked / resyncFilesOnSubmit / isOffline / useBackup / autoSync
        // / autoSaveDelay / autoSaveMode / errorDesign / hidden / pictureQuality / sampleWidth / sampleHeight)
    /*    
    actionBar.bottomBar
    //styleOptions.push(listOptions["back"](selectedData, "design"));//TODO : extrasDesign.headerMenuDesign
    //styleOptions.push(listOptions["font"](selectedData, "design"));//TODO : extrasDesign.headerMenuDesign
    //styleOptions.push(listOptions["back"](selectedData, "design"));//TODO : extrasDesign.menuDesign
    //styleOptions.push(listOptions["font"](selectedData, "design", "color"));//TODO : extrasDesign.menuDesign
    //styleOptions.push(listOptions["back"](selectedData, "design"));//TODO : extrasDesign.footerMenuDesign
    //styleOptions.push(listOptions["font"](selectedData, "design"));//TODO : extrasDesign.footerMenuDesign

    */



    var modelsOpts = {
        onMouseDown: () => {
            setTimeout(() => {
                offCanvasReportRef.current.manageVisibility(false);
            }, 200);
        },
        "gs-w": 2
    };

    return <><Row className="editor-model h-100">
            <Col className="h-100" xs="9">{content}</Col>
            <Col className="h-100 text-dark config-part" xs="3">
                {selectedData ? ((() => {
                    var path = [];

                    var getParentType = (data) => {
                        if (data.functionManager?.getParentProps) {
                            var parentProps = data.functionManager.getParentProps();
                            //Vérification sur le grid pour éviter la sélection sur  du vide
                            if (parentProps?.parentData?.grid) {
                                if (parentProps?.parentData?.functionManager?.getParentProps && parentProps.parentData.functionManager.getParentProps()?.parentData) {
                                    //path.unshift(parentProps?.parentData?.objType);
                                    path.unshift(<u className="cursor-pointer" onClick={(e) => { setSelected(parentProps.parentData.grid, parentProps.parentData) }}>{parentProps?.parentData?.objType}</u>);
                                    getParentType(parentProps.parentData/*.functionManager.getParentProps()?.parentData*/);
                                }
                                else {
                                    //path.unshift(parentProps?.parentData?.objType);
                                    path.unshift(<u className="cursor-pointer" onClick={(e) => { setSelected(parentProps.parentData.grid, parentProps.parentData) }}>{parentProps?.parentData?.objType}</u>);
                                }
                            }
                        }
                    };

                    getParentType(selectedData);

                    //path.push(selectedData.objType);
                    //return path.join(" > ");
                    path.push(<b>{selectedData.objType}</b>);
                    return path.map((item) => { return <span>{" > "}{item}</span>; });
                })()) : <h5>Modèle</h5>}


                {selectedData ? (<>
                    <div className="my-3 d-none">
                        <Button color="danger" className={``} onClick={(event) => {
                        if (selectedData.grid?.cFunctions?.removeItem) selectedData.grid?.cFunctions?.removeItem();
                        }}><i className="fa fa-trash m-0 me-2"></i>Supprimer</Button>
                    </div>

                    <Nav tabs className="my-2">
                        <NavItem>
                            <NavLink href="#" className={`${selectedTabConfig === '1' ? "active" : ""}`} onClick={() => { setSelectedTabConfig("1") }}>Eléments</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" className={`${selectedTabConfig === '2' ? "active" : ""}`} onClick={() => { setSelectedTabConfig("2") }}>Style</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" className={`${selectedTabConfig === '3' ? "active" : ""}`} onClick={() => { setSelectedTabConfig("3") }}>Actions</NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={selectedTabConfig}>
                        <TabPane tabId={"1"}>
                            {renderOptions.map(cfgOption => cfgOption)}
                            {manageGroupOthers ? <div>renderLink/groupSubName (header/category)<br />clonage etc...</div> : ""}
                        </TabPane>
                        <TabPane tabId={"2"}>
                            {styleOptions.map(cfgOption => cfgOption)}
                        </TabPane>
                        <TabPane tabId={"3"}>
                            {actionsOptions.map(cfgOption => cfgOption)}
                        </TabPane>
                    </TabContent>
                </>) : <div>
                    {(() => {
                        console.debug("CHECK BACK : " + genModel.customDesign.backColor);

                        var actionBarData;
                        if (genModel.templates?.length && genModel.templates[0].categories?.length && genModel.templates[0].categories[0].headers?.length) {
                            var groupSystem = genModel.templates[0].categories[0].headers[0].groups?.filter(g => g.groupSubName === "system");
                            if (groupSystem && groupSystem.length) {
                                var actionBar = groupSystem[0].items.filter(item => item.groupSubName === "actionBarMain");
                                if (actionBar?.length) {
                                    actionBarData = actionBar[0];
                                }
                            }
                        }

                        var pathStart = "editor.model";

                        return (<>
                            <FormGroup className="mb-0">
                                <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={genModel?.customDesign?.extrasDesign && genModel.customDesign.extrasDesign["footerMenuDesign"] ? ("#" + genModel.customDesign.extrasDesign["footerMenuDesign"].backColor?.replace("transparent", "#00FFFFFF").slice(3)) : ""} onChange={(event) => {
                                    var colorValue = event.target.value.replace("#", "#FF");
                                    console.debug(colorValue);

                                    var tempModel = commonFunc.mergeDeep({}, genModel);
                                    if (!tempModel.customDesign) tempModel.customDesign = {};
                                    if (!tempModel.customDesign.extrasDesign) tempModel.customDesign.extrasDesign = {};
                                    //if (!tempModel.customDesign.extrasDesign[path]) tempModel.customDesign.extrasDesign[path] = {};

                                    if (!tempModel.customDesign.extrasDesign["footerMenuDesign"]) tempModel.customDesign.extrasDesign["footerMenuDesign"] = {};
                                    tempModel.customDesign.extrasDesign["footerMenuDesign"].backColor = colorValue;

                                    if (tempModel.templates?.length && tempModel.templates[0].categories?.length && tempModel.templates[0].categories[0].headers?.length) {
                                        var groupSystem = tempModel.templates[0].categories[0].headers[0].groups?.filter(g => g.groupSubName === "system");
                                        if (groupSystem && groupSystem.length) {
                                            var actionBar = groupSystem[0].items.filter(item => item.groupSubName === "actionBarMain");
                                            if (actionBar && actionBar.length) {
                                                if (!actionBar[0].customDesign) actionBar[0].customDesign = {};
                                                if (!actionBar[0].customDesign.design) actionBar[0].customDesign.design = {};
                                                actionBar[0].customDesign.design.backColor = colorValue;
                                            }
                                            var floatingButton = groupSystem[0].items.filter(item => item.groupSubName === "floatingButton");
                                            if (floatingButton && floatingButton.length) {
                                                if (!floatingButton[0].customDesign) floatingButton[0].customDesign = {};
                                                if (!floatingButton[0].customDesign.design) floatingButton[0].customDesign.design = {};
                                                floatingButton[0].customDesign.design.backColor = colorValue;
                                            }
                                        }
                                    }

                                    //TODO : invalid all mergedDesign
                                    setGenModel(tempModel);
                                    setInvalidMerged(new Date().getTime());
                                    //setRerender(!rerender);
                                }} style={{ width: "50px" }} />
                                <Label className="ms-2">Couleur 1 (TopBar/FloatingBtn/FooterMenu)</Label>
                            </FormGroup>
                            <FormGroup className="mb-0">
                                <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={genModel?.customDesign?.extrasDesign && genModel.customDesign.extrasDesign["default_button"] ? ("#" + genModel.customDesign?.extrasDesign["default_button"].backColor?.replace("transparent", "#00FFFFFF").slice(3)) : ""} onChange={(event) => {
                                    var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                    console.debug(colorValue);

                                    var tempModel = commonFunc.mergeDeep({}, genModel);
                                    if (!tempModel.customDesign) tempModel.customDesign = {};
                                    if (!tempModel.customDesign.extrasDesign) tempModel.customDesign.extrasDesign = {};
                                    //if (!tempModel.customDesign.extrasDesign[path]) tempModel.customDesign.extrasDesign[path] = {};

                                    if (!tempModel.customDesign.extrasDesign["default_button"]) tempModel.customDesign.extrasDesign["default_button"] = {};
                                    tempModel.customDesign.extrasDesign["default_button"].backColor = colorValue;
                                    tempModel.customDesign.extrasDesign["default_button"].borderColor = colorValue;

                                    //TODO : invalid all mergedDesign
                                    setGenModel(tempModel);
                                    setInvalidMerged(new Date().getTime());
                                    //setRerender(!rerender);
                                }} style={{ width: "50px" }} />
                                <Label className="ms-2">Couleur 2</Label>
                            </FormGroup>
                            <FormGroup className="mb-0">
                                <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={genModel?.customDesign?.extrasDesign && genModel.customDesign.extrasDesign["widgetIcon"] ? ("#" + genModel.customDesign?.extrasDesign["widgetIcon"].fontColor?.replace("transparent", "#00FFFFFF").slice(3)) : ""} onChange={(event) => {
                                    var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                    console.debug(colorValue);

                                    var tempModel = commonFunc.mergeDeep({}, genModel);
                                    if (!tempModel.customDesign) tempModel.customDesign = {};
                                    if (!tempModel.customDesign.extrasDesign) tempModel.customDesign.extrasDesign = {};
                                    //if (!tempModel.customDesign.extrasDesign[path]) tempModel.customDesign.extrasDesign[path] = {};

                                    if (!tempModel.customDesign.extrasDesign["widgetIcon"]) tempModel.customDesign.extrasDesign["widgetIcon"] = {};
                                    tempModel.customDesign.extrasDesign["widgetIcon"].fontColor = colorValue;

                                    //TODO : invalid all mergedDesign
                                    setGenModel(tempModel);
                                    setInvalidMerged(new Date().getTime());
                                    //setRerender(!rerender);
                                }} style={{ width: "50px" }} />
                                <Label className="ms-2">Couleur 3</Label>
                            </FormGroup>
                            <FormGroup className="mb-0">
                                <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={genModel?.customDesign?.extrasDesign && genModel.customDesign.extrasDesign["default_button"] ? ("#" + genModel.customDesign?.extrasDesign["default_button"].fontColor?.replace("transparent", "#00FFFFFF").slice(3)) : ""} onChange={(event) => {
                                    var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                    console.debug(colorValue);

                                    var tempModel = commonFunc.mergeDeep({}, genModel);
                                    if (!tempModel.customDesign) tempModel.customDesign = {};
                                    if (!tempModel.customDesign.extrasDesign) tempModel.customDesign.extrasDesign = {};
                                    //if (!tempModel.customDesign.extrasDesign[path]) tempModel.customDesign.extrasDesign[path] = {};

                                    if (!tempModel.customDesign.extrasDesign["default_button"]) tempModel.customDesign.extrasDesign["default_button"] = {};
                                    tempModel.customDesign.extrasDesign["default_button"].fontColor = colorValue;
                                    if (!tempModel.customDesign.extrasDesign["default_textviewTitle"]) tempModel.customDesign.extrasDesign["default_textviewTitle"] = {};
                                    tempModel.customDesign.extrasDesign["default_textviewTitle"].fontColor = colorValue;

                                    if (tempModel.templates?.length && tempModel.templates[0].categories?.length && tempModel.templates[0].categories[0].headers?.length) {
                                        var groupSystem = tempModel.templates[0].categories[0].headers[0].groups?.filter(g => g.groupSubName === "system");
                                        if (groupSystem && groupSystem.length) {
                                            var actionBar = groupSystem[0].items.filter(item => item.groupSubName === "actionBarMain");
                                            if (actionBar && actionBar.length) {
                                                if (!actionBar[0].customDesign) actionBar[0].customDesign = {};
                                                if (!actionBar[0].customDesign.design) actionBar[0].customDesign.design = {};
                                                actionBar[0].customDesign.design.fontColor = colorValue;
                                            }
                                        }
                                    }

                                    //TODO : invalid all mergedDesign
                                    setGenModel(tempModel);
                                    setInvalidMerged(new Date().getTime());
                                    //setRerender(!rerender);
                                }} style={{ width: "50px" }} />
                                <Label className="ms-2">Couleur Texte</Label>
                            </FormGroup>


                            <div className="mt-3">
                                <Label>
                                    {t(pathStart + "back") !== (pathStart + "back") ? t(pathStart + "back") : t("editor.designback")}
                                </Label>
                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + genModel?.customDesign?.design?.backColor?.replace("transparent", "#00FFFFFF").slice(3)} onChange={(event) => {
                                        var tempModel = commonFunc.mergeDeep({}, genModel);
                                        if (!tempModel.customDesign) tempModel.customDesign = {};
                                        if (!tempModel.customDesign.design) tempModel.customDesign.design = {};
                                        tempModel.customDesign.design.backColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                        //cfgData.mergedDesign = null;

                                        //TODO : invalid all mergedDesign
                                        setGenModel(tempModel);
                                        setInvalidMerged(new Date().getTime());
                                        //setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t(pathStart + "backcolor") !== (pathStart + "backcolor") ? t(pathStart + "backcolor") : t("editor.designbackcolor")}</Label>
                                    <CImageSelector className="mt-0" files={appProps?.getSite()?.files} currentPath={() => {
                                        if (genModel?.customDesign?.design?.backColor?.startsWith("#")) return "";
                                        else return (genModel?.customDesign?.design?.backColor || "");
                                    }} withSystemFiles={true} onChange={(imageObj) => {
                                        if (imageObj) {
                                            var tempModel = commonFunc.mergeDeep({}, genModel);
                                            if (!tempModel.customDesign) tempModel.customDesign = {};
                                            if (!tempModel.customDesign.design) tempModel.customDesign.design = {};

                                            if (imageObj.isSystem) {

                                                //TEMP PATCH : supprime l'extension pour compatibilité android
                                                var splitName = imageObj.name.split(".");
                                                splitName.pop();
                                                imageObj.name = splitName.join(".");

                                                commonFunc.setValue(tempModel, "customDesign.design.backColor", "draw:" + imageObj.name);
                                            }
                                            else {
                                                commonFunc.setValue(tempModel, "customDesign.design.backColor", "/" + imageObj.name);
                                            }

                                            //TODO : invalid all mergedDesign
                                            setGenModel(tempModel);
                                            setInvalidMerged(new Date().getTime());
                                            //setRerender(!rerender);
                                        }
                                    }} />
                                </FormGroup>

                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + genModel?.customDesign?.design?.borderColor?.replace("transparent", "#00FFFFFF").slice(3)} onChange={(event) => {
                                        var tempModel = commonFunc.mergeDeep({}, genModel);
                                        if (!tempModel.customDesign) tempModel.customDesign = {};
                                        if (!tempModel.customDesign.design) tempModel.customDesign.design = {};
                                        tempModel.customDesign.design.borderColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha

                                        //TODO : invalid all mergedDesign
                                        setGenModel(tempModel);
                                        setInvalidMerged(new Date().getTime());
                                        //setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t(pathStart + "bordercolor") !== (pathStart + "bordercolor") ? t(pathStart + "bordercolor") : t("editor.designbordercolor")}</Label>
                                </FormGroup>

                                <div>
                                    <Label className="">{t(pathStart + "bordersize") !== (pathStart + "bordersize") ? t(pathStart + "bordersize") : t("editor.designbordersize")}</Label>
                                    <FormGroup className="mb-0">
                                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(genModel?.customDesign?.design?.borderSize?.replace("px", "") || "0")} onChange={(event) => {
                                            var tempModel = commonFunc.mergeDeep({}, genModel);
                                            if (!tempModel.customDesign) tempModel.customDesign = {};
                                            if (!tempModel.customDesign.design) tempModel.customDesign.design = {};
                                            tempModel.customDesign.design.borderSize = event.target.value + "px";

                                            //TODO : invalid all mergedDesign
                                            setGenModel(tempModel);
                                            setInvalidMerged(new Date().getTime());
                                            //setRerender(!rerender);
                                        }} style={{ width: "50px" }} />
                                        <Label className="ms-2">px</Label>
                                    </FormGroup>
                                </div>

                                <div>
                                    <Label className="">{t(pathStart + "borderradius") !== (pathStart + "borderradius") ? t(pathStart + "borderradius") : t("editor.designborderradius")}</Label>
                                    <div>
                                        <div className={`form-check-radio fcheck-sm d-inline-block me-3`}>
                                            <Label check >
                                                <Input id={`radio_valmodeldesign`} name={"radiomodeldesign"} defaultChecked={true} type="radio" value={"1"} onChange={(e) => {
                                                    var value = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);

                                                }} />
                                                <span className="form-check-sign" />
                                                {t("editor.radiusValue")}
                                            </Label>
                                        </div>
                                        <div className={`form-check-radio fcheck-sm d-inline-block`}>
                                            <Label check >
                                                <Input id={`radio_pctmodeldesign`} name={"radiomodeldesign"} defaultChecked={false} type="radio" value={"2"} onChange={(e) => {
                                                    var value = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);

                                                }} />
                                                <span className="form-check-sign" />
                                                {t("editor.radiusPct")}
                                            </Label>
                                        </div>
                                    </div>
                                    <FormGroup className="mb-0">
                                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(genModel?.customDesign?.design?.borderRadius?.replace("px", "") || "0")} onChange={(event) => {
                                            var tempModel = commonFunc.mergeDeep({}, genModel);
                                            if (!tempModel.customDesign) tempModel.customDesign = {};
                                            if (!tempModel.customDesign.design) tempModel.customDesign.design = {};
                                            tempModel.customDesign.design.borderRadius = event.target.value + "px";

                                            //TODO : invalid all mergedDesign
                                            setGenModel(tempModel);
                                            setInvalidMerged(new Date().getTime());
                                            //setRerender(!rerender);
                                        }} style={{ width: "100px" }} />
                                        <Label className="ms-2">px</Label>
                                    </FormGroup>
                                    <FormGroup className="mb-0">
                                        <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" min="0" max="50" value={(genModel?.customDesign?.design?.borderRadius?.replace("%", "") || "0")} onChange={(event) => {
                                            var tempModel = commonFunc.mergeDeep({}, genModel);
                                            if (!tempModel.customDesign) tempModel.customDesign = {};
                                            if (!tempModel.customDesign.design) tempModel.customDesign.design = {};
                                            tempModel.customDesign.design.borderRadius = event.target.value + "%";

                                            //TODO : invalid all mergedDesign
                                            setGenModel(tempModel);
                                            setInvalidMerged(new Date().getTime());
                                            //setRerender(!rerender);
                                        }} style={{ width: "100px" }} />
                                        <Label className="ms-2">%</Label>
                                    </FormGroup>
                                </div>
                            </div>

                            {actionBarData ? <>
                                <h6 className="fw-bold">{t("editor.actionBar.label")}</h6>

                                <FormGroup className="mb-0">
                                    <Label for={"titleActionBar"}>
                                        {t("editor.actionBar.title")}
                                    </Label>
                                    <Input id={"titleActionBar"} type="text" value={actionBarData.title} onChange={(event) => {
                                        actionBarData.title = event.target.value;
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} />
                                </FormGroup>

                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={!commonFunc.isBlank(actionBarData.customDesign?.design?.backColor) ? ("#" + actionBarData.customDesign?.design.backColor?.replace("transparent", "#00FFFFFF").slice(3)) : "#0099CC"} onChange={(event) => {
                                        var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                        if (!actionBarData.customDesign) actionBarData.customDesign = {};
                                        if (!actionBarData.customDesign.design) actionBarData.customDesign.design = {};
                                        actionBarData.customDesign.design.backColor = colorValue;
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t("editor.actionBar.backColor")}</Label>
                                </FormGroup>
                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={!commonFunc.isBlank(actionBarData.customDesign?.design?.fontColor) ? ("#" + actionBarData.customDesign?.design.fontColor?.replace("transparent", "#00FFFFFF").slice(3)) : "#FFFFFF"} onChange={(event) => {
                                        var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                        if (!actionBarData.customDesign) actionBarData.customDesign = {};
                                        if (!actionBarData.customDesign.design) actionBarData.customDesign.design = {};
                                        actionBarData.customDesign.design.fontColor = colorValue;
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t("editor.actionBar.fontColor")}</Label>
                                </FormGroup>

                                <h6 className="fw-bold">{t("editor.progressBar.label")}</h6>

                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={!commonFunc.isBlank(actionBarData.customDesign?.designInput?.backColor) ? ("#" + actionBarData.customDesign?.designInput.backColor?.replace("transparent", "#00FFFFFF").slice(3)) : "#0099CC"} onChange={(event) => {
                                        var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                        if (!actionBarData.customDesign) actionBarData.customDesign = {};
                                        if (!actionBarData.customDesign.designInput) actionBarData.customDesign.designInput = {};
                                        actionBarData.customDesign.designInput.backColor = colorValue;
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t("editor.progressBar.backColor")}</Label>
                                </FormGroup>
                                <FormGroup className="mb-0">
                                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={!commonFunc.isBlank(actionBarData.customDesign?.designInput?.fontColor) ? ("#" + actionBarData.customDesign?.designInput.fontColor?.replace("transparent", "#00FFFFFF").slice(3)) : "#FFFFFF"} onChange={(event) => {
                                        var colorValue = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                                        if (!actionBarData.customDesign) actionBarData.customDesign = {};
                                        if (!actionBarData.customDesign.designInput) actionBarData.customDesign.designInput = {};
                                        actionBarData.customDesign.designInput.fontColor = colorValue;
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} style={{ width: "50px" }} />
                                    <Label className="ms-2">{t("editor.progressBar.fontColor")}</Label>
                                </FormGroup>
                                <FormGroup className="mb-0">
                                    <Label>{t("editor.progressBar.height")}</Label>
                                    <Input type="number" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={(!commonFunc.isBlank(actionBarData.customDesign?.designInput?.height) ? actionBarData.customDesign.designInput.height.replace("px", "") : "0")} onChange={(event) => {
                                        if (!actionBarData.customDesign) actionBarData.customDesign = {};
                                        if (!actionBarData.customDesign.designInput) actionBarData.customDesign.designInput = {};
                                        actionBarData.customDesign.designInput.height = event.target.value + "px";
                                        genModel.functionManager.rerender();
                                        setRerender(!rerender);
                                    }} style={{ width: "100px" }} />
                                    <Label className="ms-2">px</Label>
                                </FormGroup>
                            </> : ""}
                        </>);
                    })()}

                    {renderOptions.map(cfgOption => cfgOption)}
                </div>}

            </Col>
        </Row>
        <OffCanvas className={``} btnGroupClass={"d-none"} ref={offCanvasReportRef} onOpened={() => { GridStack.setupDragIn('.models-container .grid-model', { appendTo: 'body', helper: "clone" }); }}
            direction={"end"} title={"Ajout Composant"} backdrop={false} scrollable={true}>

            <div className="d-none">TODO mix Accordion</div>

            <div className="models-container">
                <h5 className="fw-bold">Conteneur</h5>

                <div className="grid-stack-item grid-model grid-category" bind-type="category" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Categorie</div></div>
                <div className="grid-stack-item grid-model grid-header" bind-type="header" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Sous-Categorie</div></div>
                <div className="grid-stack-item grid-model grid-group" bind-type="group" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Groupe</div></div>
                <div className="grid-stack-item grid-model grid-itemsContainer" bind-type="itemsContainer" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Ensemble</div></div>

                <h5 className="fw-bold">Champs</h5>

                <div className="grid-stack-item grid-model grid-item" bind-type="textview" {...modelsOpts}><div className="grid-stack-item-content text-dark">Titre</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="text" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Champ Texte</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="dropdown" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Liste déroulante</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="checkbox" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Case à cocher</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="radio" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Liste d'élément</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="picture" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Photo</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="canvas" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Signature</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="image" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Image</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="button" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Bouton</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="collapse" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Texte déroulant (TODO)</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="openFile" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Fichier (TODO)</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="list" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Liste (TODO)</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="finder" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Champs Rattachement (WEB)</div></div>

                <h5 className="fw-bold">Champs Pré-construits</h5>

                <div className="grid-stack-item grid-model grid-item" bind-type="date" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Date</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="time" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Heure</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="email" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Email</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="phone" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Téléphone</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="password" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Mot de passe</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="float" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Nombre décimal</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="integer" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Nombre Entier</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="pictureComment" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Photo+Commentaire</div></div>
            </div>
        </OffCanvas>
    </>;

});

export default AConfigureModel;

export function getRgbaFromHex(hex) {
    if (hex.length == 9) {
        var alpha = parseInt(hex.slice(1, 3), 16) / 255;
        var hex = commonFunc.hexToRgb(hex.substring(3));
        var rgba = "rgba(" + hex + "," + alpha.toFixed(2) + ")";

        return rgba;
    } else {
        return commonFunc.hexToRgb(hex);
    }
}

export function convertWidthToGrid(widthPercent, withoutClass) {
    var gridValue = Math.round(widthPercent / 100 * 12);
    if (withoutClass) return gridValue;
    return " col-12 col-md-" + gridValue;
}

export function finalizeProcess(data, parentProps, containerGridM) {
    var childCount = parentProps?.parentData?.childCount || 1;
    var childLoaded = parentProps?.parentData?.childLoaded || 0;
    if (!data.loaded) {
        data.loaded = true;
        parentProps.parentData.childLoaded = childLoaded + 1;

        console.debug("GO FINALIZE " + data.objType + " " + parentProps.parentData.childLoaded + "/" + childCount);

        if (parentProps.parentData.childLoaded >= childCount && !parentProps.parentData.loaded) {
            var parentSupProps = parentProps?.parentData?.functionManager?.getParentProps() || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()
                || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.functionManager?.getParentProps();
            if (parentSupProps) finalizeProcess(parentProps.parentData, parentSupProps);
            else if (parentProps.parentData.objType === "model") parentProps.parentData.functionManager.finalizeModel();
        }
    }
}

function getMergedDesign(data, designFragment, rootDesign, forcedMerge) {
    if ((forcedMerge || !data.mergedDesign)) {
        if (!designFragment) {
            designFragment = rootDesign;
        } else if (rootDesign) {
            designFragment = Object.assign({}, rootDesign, designFragment);
        }
    }
    else {
        designFragment = forcedMerge ? designFragment : data.mergedDesign;
    }
    return designFragment;
}


function SubGenModal({ t, title, configModel, dataCfg, appProps, checkRights, getRoutes, genRef, genId, genType, subType, itemData, noScroll, size, dataElem, callback }) {
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    return (
        <Modal isOpen={true} className={`modal-${itemData.subType} ${noScroll ? "modal-noscroll" : ""}`} size={size ? size : "xxl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <AGenerateModel ref={genRef} noButtons onSubmit={(data, isUpdate, test) => callback(data, isUpdate, test)} appProps={appProps} checkRights={checkRights} getRoutes={getRoutes} parentProps={{ id: genId, type: genType, subType: subType, dataCfg: dataCfg }} keyMode={2} configModel={configModel} loadedData={dataElem} showActionBar={true} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t(subType + "_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}